var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// ANNOUNCEMENT BAR
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const hasMultipleSlides = this.querySelectorAll(".swiper-slide").length > 1;

    if (!hasMultipleSlides) return;

    const autoplay = this.dataset.autoplay === "true";
    const speed = parseInt(this.dataset.autoplaySpeed * 1000) || 3000;
    const fade = this.dataset.fade;
    let effect = "slide";
    if (fade == "true") {
      effect = "fade";
    }

    const swiper = new Swiper(
      this.querySelector(".announcement_bar_inner.has_multiple_announcements"),
      {
        loop: true,
        speed: 1000,
        grabCursor: true,
        autoplay: autoplay
          ? { delay: speed, disableOnInteraction: false }
          : false,
        effect: effect,
        fadeEffect: { crossFade: true },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          640: {
            slidesPerView: 1            
          }
        }
      }
    );
  }
}
customElements.define("announcement-bar", AnnouncementBar);


// STICKY HEADER
const header = document.querySelector(".header-section");

// window.addEventListener(
//   "scroll",
//   () => {
//     header?.classList.toggle("sticky-header", window.scrollY > 10);
//   },
//   { passive: true }
// );
// FOLLOW CURSOR
document.addEventListener("DOMContentLoaded", () => {
  let cursorPointer = document.querySelector(".cursor_pointer");
  let links = document.querySelectorAll("a, .links");
  let swiperWrapper = document.querySelectorAll(".main-swiper-wrapper");
  let footerWrapper = document.querySelector('.footer_wrapper');
  let swiperBtns = document.querySelectorAll(".swiper-buttons");
  let product_card_infos = document.querySelectorAll('.product_card_info');
  let mainCartWrapper = document.querySelector('.main_cart_inner');
  

  if (!cursorPointer) return;

  let mouseX = 0,
    mouseY = 0;
  let posX = 0,
    posY = 0;
  let speed = 0.1;

  const cursorWidth = cursorPointer.offsetWidth;
  const cursorHeight = cursorPointer.offsetHeight;

  function updateCursorPosition(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  }

  function smoothMove() {
    posX += (mouseX - posX) * speed;
    posY += (mouseY - posY) * speed;

    cursorPointer.style.transform = `translate(${posX - cursorWidth / 2}px, ${
      posY - cursorHeight / 2
    }px)`;
    requestAnimationFrame(smoothMove);
  }

  document.addEventListener("mousemove", updateCursorPosition);
  requestAnimationFrame(smoothMove);

  links.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      cursorPointer.classList.add("grow");
    });
    link.addEventListener("mouseleave", () => {
      cursorPointer.classList.remove("grow");
    });
  });

  // swiperWrapper.forEach((swiper) => {
  //   let pc_imgs = swiper.querySelectorAll('.product_card_img');
  //   pc_imgs.forEach((imgs) => {
  //     imgs.addEventListener("mouseenter", () => {
  //       cursorPointer.classList.add("swipe");
  //     });

  //     imgs.addEventListener("mouseleave", () => {
  //       cursorPointer.classList.remove("swipe");
  //     });
  //   })  
  // });

  // swiperBtns.forEach((btn) => {
  //   btn.addEventListener("mouseenter", () => {
  //     cursorPointer.classList.remove("swipe");
  //   });
  //   btn.addEventListener("mouseleave", () => {
  //     cursorPointer.classList.add("swipe");
  //   });
  // });

  footerWrapper.addEventListener('mouseenter', () => {
    cursorPointer.style.visibility = 'hidden';
  })

  footerWrapper.addEventListener('mouseleave', () => {
    cursorPointer.style.visibility = 'visible';
  })

  if(mainCartWrapper) {
    let noteWrapper = mainCartWrapper.querySelector('.cart_note_wrapper');
    let noteInner = noteWrapper.querySelector('.cart_note_inner');

    noteWrapper.addEventListener('mouseenter', () => {
      cursorPointer.classList.add('close');
    })

    noteInner.addEventListener('mouseenter', () => {
      cursorPointer.classList.remove('close');
    })

    noteInner.addEventListener('mouseleave', () => {
      if(noteWrapper.classList.contains('active')) {
        cursorPointer.classList.add('close');
      }
    })
  }  
});



// SLIDESHOW SLIDER
class SlideshowSlider extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.spacing = Number(this.dataset.spacing) || 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = Number(this.dataset.autoplaySpeed) * 1000 || 3000;
    this.effect = this.dataset.effect || 'slide';
    this.slider = this.querySelector(`.ssw-${this.sectionId}`);
  }

  connectedCallback() {
    if (!this.slider) return;

    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: this.spacing,
      speed: 800,
      loop: true,
      effect: this.effect,
      autoHeight:true,
      autoplay: this.autoplay
        ? {
            delay: this.speed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      navigation: {
        nextEl: `.slideshow_next_btn-${this.sectionId}`,
        prevEl: `.slideshow_prev_btn-${this.sectionId}`
      },
    });
  }
}
customElements.define('slideshow-slider', SlideshowSlider);


// COLLECTION LIST
class CollectionList extends HTMLElement {
  constructor() {
    super();
    this.spacing = this.dataset.spacing;
    this.sectionId = this.dataset.sectionId;
    this.dataStyle = this.dataset.collStyle;
  }

  connectedCallback() {
    const hasMultipleSlides = this.querySelectorAll(".swiper-slide").length > 1;
    if (!hasMultipleSlides) return;

    if(this.dataStyle == 'style1') {
      const swiper = new Swiper(
      this.querySelector(".collection_list_blocks_wrapper"),
      {
        speed: 800,
        grabCursor: true,
        slidesPerView: 3.2,
        spaceBetween: this.spacing,
        navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: this.spacing,
        },
        640: {
          slidesPerView: 2.2,
          spaceBetween: this.spacing,
        },
        768: {
          slidesPerView: 3.2,
          spaceBetween: this.spacing,
        },                
        1399: {
          slidesPerView: 3.2,
          spaceBetween: this.spacing,
        },
      }
      }
    );
    } else {
      const swiper = new Swiper(
      this.querySelector(".collection_list_blocks_wrapper"),
      {
        speed: 800,
        grabCursor: true,
        slidesPerView: 4.3,
        spaceBetween: this.spacing,
        navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: this.spacing,
        },
        640: {
          slidesPerView: 2.2,
          spaceBetween: this.spacing,
        },
        768: {
          slidesPerView: 3.2,
          spaceBetween: this.spacing,
        },                
        1399: {
          slidesPerView: 4.3,
          spaceBetween: this.spacing,
        }
      }
      }
    );
    }

    
  }
}
customElements.define("collection-list", CollectionList);


// FEATURED COLLECTION
class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.spacing = this.dataset.spacing;
    this.sectionId = this.dataset.sectionId;
    this.columns = this.dataset.columns;
    this.mobColumns = this.dataset.mobColumns;
  }

  connectedCallback() {
    const hasMultipleSlides =
      this.querySelectorAll(".featured_collection_block.swiper-slide").length > 1;   

    if (!hasMultipleSlides) return;

    const swiper = new Swiper(
      this.querySelector(".featured_collection_inner.has_collection.swiper"),
      {
        speed: 800,
        grabCursor: true,
        slidesPerView: this.columns,
        spaceBetween: this.spacing,
        navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
        0: {
          slidesPerView: this.mobColumns,
          spaceBetween: this.spacing,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: this.spacing,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: this.spacing,
        },
        1281: {
          slidesPerView: 4,
          spaceBetween: this.spacing,
        },                
        1399: {
          slidesPerView: this.columns,
          spaceBetween: this.spacing,
        },
      }
      }
    );           
  }
}
customElements.define("featured-collection", FeaturedCollection);



// FEATURED CONTENT
class FeaturedContentCollection extends HTMLElement {
  constructor() {
    super();
    this.spacing = this.dataset.spacing;
    this.columns = this.dataset.columns;
    this.mobColumns = this.dataset.mobColumns;
  }

  connectedCallback() {
    const hasMultipleSlides =
      this.querySelectorAll(".featured_content_collection_block.swiper-slide").length > 1;   

    if (!hasMultipleSlides) return;

    const swiper = new Swiper(
      this.querySelector(".featured_collection_inner.has_collection.swiper"),
      {
        speed: 800,
        grabCursor: true,
        slidesPerView: this.columns,
        spaceBetween: this.spacing,
        navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
        0: {
          slidesPerView: this.mobColumns,
          spaceBetween: this.spacing,
        },
        640: {
          slidesPerView: 2.2,
          spaceBetween: this.spacing,
        },
        768: {
          slidesPerView: 3.2,
          spaceBetween: this.spacing,
        },  
        991: {
          slidesPerView: 3,
          spaceBetween: this.spacing,
        },              
        1250: {
          slidesPerView: this.columns,
          spaceBetween: this.spacing,
        }
      }
      }
    );           
  }
}
customElements.define("featured-content", FeaturedContentCollection);


// ROUNDED COLLECTION 
class RoundedCollection extends HTMLElement {
  constructor() {
    super();
    this.spacing = Number(this.dataset.spacing) || 20;
    this.columns = Number(this.dataset.columns) || 3;
    this.mobColumns = Number(this.dataset.mobColumns) || 1;
  }

  connectedCallback() {
    const container = this.querySelector(".rounded_collection_inner");
    if (!container) return;

    const wrapper = container.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    const slideItems = wrapper.querySelectorAll(".swiper-slide");
    if (slideItems.length <= 1) return;

    new Swiper(container, {
      speed: 800,
      grabCursor: true,
      slidesPerView: this.columns,
      spaceBetween: this.spacing,

      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },

      breakpoints: {
        0: {
          slidesPerView: this.mobColumns,
          spaceBetween: this.spacing,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: this.spacing,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: this.spacing,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: this.spacing,
        },
          1440: {
          slidesPerView: 4,
          spaceBetween: this.spacing,
        },
        1631: {
          slidesPerView: this.columns,
          spaceBetween: this.spacing,
        }
      }
    });
  }
}
customElements.define("rounded-collection", RoundedCollection);


// VIDEO REVIEW
class VideoReview extends HTMLElement {
  constructor() {
    super();
    this.spacing = Number(this.dataset.spacing) || 20;
    this.columns = Number(this.dataset.columns) || 3;
    this.mobColumns = Number(this.dataset.mobColumns) || 1;
  }

  connectedCallback() {
    // Corrected container class
    const container = this.querySelector(".review_inner");
    if (!container) return;

    // Correct swiper-wrapper
    const wrapper = container.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    const slideItems = wrapper.querySelectorAll(".swiper-slide");
    if (slideItems.length <= 1) return;

    // Initialize Swiper
    new Swiper(container, {
      speed: 800,
      grabCursor: true,
      slidesPerView: this.columns,
      spaceBetween: this.spacing,

      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },

      breakpoints: {
        0: {
          slidesPerView: this.mobColumns,
          spaceBetween: this.spacing,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: this.spacing,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: this.spacing,
        },
        1200: {
          slidesPerView: this.columns,
          spaceBetween: this.spacing,
        }
      }
    });
  }
}
customElements.define("video-review", VideoReview);




// PRODUCT CARD
class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.spacing = this.dataset.spacing;
    this.anchor = this.querySelector('.product_card_img a:first-child')
    this.colorInputs = this.querySelectorAll('.color_input');
    this.swipers = [];
  }

  connectedCallback() {
    const hasMultipleImages = this.querySelectorAll(".product_card_img.swiper");
    if(!hasMultipleImages) return;

    hasMultipleImages.forEach((image) => {
      const imageSwiper = new Swiper(image, {
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 0,
        a11y: false,
        navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
        },
      });

    this.swipers.push(imageSwiper);

    });


    if(this.colorInputs) {
      this.colorInputs.forEach((colorInput) => {
        colorInput.addEventListener('click', () => {
          const imgUrl = colorInput.dataset.variantImage;

          this.swipers.forEach((swiper) => {
            const targetIndex = Array.from(swiper.slides).findIndex(
              (slide) => {                
                const index = slide.dataset.src == imgUrl;
                return index;
              }
            )

            if(targetIndex !== -1) {
              swiper.slideTo(targetIndex)
            }
          })
          
        })
      })
    } 

    if(this.anchor) {
      this.anchor.addEventListener('focusin', (e) => {
        const el = e.target;
        if(el.matches(':focus-visible')) {
          if(!this.colorInputs) return;
          this.colorInputs.forEach((input) => {
            input.style.visibility = 'visible'
          })          
        }
      })
    }
  }
}
customElements.define('product-card', ProductCard);


// FEATURED BLOG
class FeaturedBlog extends HTMLElement {
  constructor() {
    super();
    this.spacing = this.dataset.spacing;
    this.slider = this.querySelector('.featured_block_inner');
    this.columns = this.dataset.columns;
    this.prevBtn = this.previousElementSibling.querySelector('.swiper-button-prev');
    this.nextBtn = this.previousElementSibling.querySelector('.swiper-button-next');
  }

  connectedCallback() {
    const hasMultipleSlides =
      this.querySelectorAll(".featured_article.swiper-slide").length > 1;

    if (!hasMultipleSlides) return;

    const swiper = new Swiper(this.slider,
      {
        speed: 600,
        grabCursor: true,
             slidesPerView: this.columns,
        spaceBetween: this.spacing,
        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },
        breakpoints: {        
        0: {
          slidesPerView: 1,
          spaceBetween: this.spacing,
        },
        768: {
          slidesPerView: 1.2,
          spaceBetween: this.spacing,
        },
        991: {
          slidesPerView: 1.2,
          spaceBetween: this.spacing,
        },                               
        1280: {
              slidesPerView: this.columns,
          spaceBetween: this.spacing,
        }
      }
      }
    );
  }
}
customElements.define("featured-blog", FeaturedBlog);


// VIDEO SECTION
class VideoSection extends HTMLElement {
  constructor() {
    super();

    this.playIcon = this.querySelector(".play_icon_wrapper");

    this.imageContainer = this.querySelector(
      ".video_section_poster_image_wrapper"
    );

    this.videoContainer = this.querySelector(".video_section_video_wrapper");
    this.video = this.videoContainer?.querySelector("video");
    this.iframe = this.videoContainer?.querySelector("iframe");
  }

  connectedCallback() {
    if (this.playIcon && this.imageContainer && this.videoContainer) {
      this.playIcon.addEventListener("click", this.handleClick);
    }
  }

  disconnectedCallback() {
    this.playIcon?.removeEventListener("click", this.handleClick);
  }

  handleClick = () => {
    if (!this.video && !this.iframe) return;

    this.imageContainer.classList.add("nodisp");

    setTimeout(() => {
      this.imageContainer.style.display = "none";
      this.videoContainer.style.display = "block";
      requestAnimationFrame(() => this.videoContainer.classList.add("disp"));

      if (this.video) {
        this.video.play();
      } else if (this.iframe) {
        const src = this.iframe.getAttribute("src");
        if (src.includes("youtube.com") || src.includes("youtu.be")) {
          this.iframe.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            "*"
          );
        } else if (src.includes("vimeo.com")) {
          this.iframe.contentWindow.postMessage(
            '{"method":"play"}',
            "https://player.vimeo.com"
          );
        }
      }
    }, 500);
  };
}
customElements.define("video-section", VideoSection);


// SCROLLING IMAGES
class ScrollingImages extends HTMLElement {
  constructor() {
    super();
    this.scrollingItems = this.querySelectorAll('.scrolling_images_items');    
  }
  connectedCallback() {
    let images = this.querySelectorAll(".scrolling_images_items");
    this.handleObserver(images);

    this.scrollingItems.forEach((item) => {
      const anchor = item.querySelector('a');
      if(!anchor) return;
      anchor.addEventListener('focus', (e) => {
        if(e.target.matches(':focus-visible')) {
          item.style.outline = '1px solid black'
        }
      })

      anchor.addEventListener('blur', (e) => {
          item.style.outline = 'none';        
      })
    })
  }

  handleObserver(images) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.init();
        });
      },
      {
        threshold: 0.1,
      }
    );
    images.forEach((image) => {
      observer.observe(image);
    });
  }

  decorateImages() {
    this.querySelectorAll(".scrolling_images_items").forEach((item, index) => {
      item.classList.add(
        `scrolling_images_items--${index % 2 === 0 ? "odd" : "even"}`
      );
    });
  }
  rotateOnScroll() {
    const images = this.querySelectorAll(".scrolling_images_items"),
      maxRotation = parseInt(this.dataset.rotation, 10) || 5;

    document.addEventListener("scroll", function () {
      images.forEach((image) => {
        const imageRect = image.getBoundingClientRect(),
          windowHeight = window.innerHeight;
        if (imageRect.top < windowHeight) {
          let visiblePercent =
              ((windowHeight - imageRect.top) / windowHeight) * 100,
            rotationDegree = Math.min(
              (visiblePercent / 100) * maxRotation,
              maxRotation
            );
          image.classList.contains("scrolling_images_items--odd") &&
            (rotationDegree *= -1),
            window.requestAnimationFrame(() => {
              image.style.transform = `translate3d(0px, 0px, 0px) rotate(${rotationDegree}deg)`;
            });
        }
      });
    });
  }
  init() {
    this.decorateImages(), this.rotateOnScroll();
  }
}
customElements.define("scrolling-images", ScrollingImages);


// LOGO LIST
class LogoList extends HTMLElement {
  constructor() {
    super();
    this.scroller = null;
    this.track = null;
    this.row = null;
    this.animationProps = {
      pxPerSecond: 80,
      dir: 'left',
      pauseOnHover: false
    };
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.scroller = this.querySelector('.logo_list_scroller.is-marquee');
    if (!this.scroller) return;

    this.track = this.querySelector('.logo_list_track');
    this.row = this.querySelector('.logo_row');

    if (!this.track || !this.row) {
      console.error('Missing required elements:', { scroller: this.scroller, track: this.track, row: this.row });
      return;
    }

    this._initAnimation();
    this._setupEventListeners();
  }

  disconnectedCallback() {
    this._cleanupEventListeners();
  }

  _initAnimation() {
    this.animationProps = {
      pxPerSecond: Number(this.scroller.dataset.speed) || 80,
      dir: (this.scroller.dataset.direction || 'left').toLowerCase(),
      pauseOnHover: this.scroller.dataset.pause === 'true'
    };

    this._waitForImages().then(() => this._setupResizeObserver());
  }

  _waitForImages() {
    const imgs = this.scroller.querySelectorAll('img');
    if (imgs.length === 0) {
      this._setAnimation();
      return Promise.resolve();
    }

    return Promise.all(
      Array.from(imgs).map(img => 
        img.complete 
          ? Promise.resolve() 
          : new Promise(resolve => {
              img.addEventListener('load', resolve, { once: true });
              img.addEventListener('error', resolve, { once: true });
            })
      )
    ).then(() => this._setAnimation());
  }

  _setupResizeObserver() {
    this._cleanupResizeObserver();
    this.resizeObserver = new ResizeObserver(() => this._setAnimation());
    this.resizeObserver.observe(this.scroller);
  }

  _setupEventListeners() {
    if (this.animationProps.pauseOnHover) {
      this.scroller.addEventListener('mouseenter', this._pauseAnimation);
      this.scroller.addEventListener('mouseleave', this._resumeAnimation);
    }
  }

  _cleanupEventListeners() {
    if (this.scroller && this.animationProps.pauseOnHover) {
      this.scroller.removeEventListener('mouseenter', this._pauseAnimation);
      this.scroller.removeEventListener('mouseleave', this._resumeAnimation);
    }
  }

  _cleanupResizeObserver() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  _pauseAnimation = () => {
    this.track.style.animationPlayState = 'paused';
  };

  _resumeAnimation = () => {
    this.track.style.animationPlayState = 'running';
  };

  _setAnimation() {
    if (!this.track || !this.row) return;

    const distance = this.row.scrollWidth;
    const duration = distance / Math.max(this.animationProps.pxPerSecond, 1);

    this.track.style.setProperty('--distance', `${distance}px`);
    this.track.style.setProperty('--duration', `${duration}s`);
    this.track.style.setProperty('--direction', this.animationProps.dir === 'right' ? 'reverse' : 'normal');

    // Restart animation
    this.track.classList.remove('is-animating');
    void this.track.offsetWidth; // Trigger reflow
    this.track.classList.add('is-animating');
  }
}
customElements.define('logo-list', LogoList);


// LOOKBOOK SECTION
class LookbookSection extends HTMLElement {
  constructor() {
    super();
    this.inner = null;
    this.blocks = [];
    this._raf = null;
    this._onScroll = this._onScroll.bind(this);
    this._update = this._update.bind(this);
  }

  connectedCallback() {
    this.inner = this.querySelector('.lookbook_inner');
    if (!this.inner) return;

    this.blocks = Array.from(this.inner.querySelectorAll('.lookbook_block'));

    const n = this.blocks.length;
    this.blocks.forEach((el, i) => {
      el.style.setProperty('--z', String(i));

      const anchor = el.querySelector('a');
      if(!anchor) return;
      anchor.addEventListener('focus', (e) => {
        if(e.target.matches(':focus-visible')) {
          anchor.closest('.lookbook_img_block').style.outline = '1px solid black';
        }
      })

      anchor.addEventListener('blur', (e) => {
          anchor.closest('.lookbook_img_block').style.outline = 'none';       
      })
    });

    this._update();

    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onScroll);
    if (this._raf) cancelAnimationFrame(this._raf);
  }

  _onScroll() {
    if (this._raf) return;
    this._raf = requestAnimationFrame(this._update);
  }

  _update() {
    this._raf = null;
    const vh = window.innerHeight || document.documentElement.clientHeight;

    for (let i = 0; i < this.blocks.length; i++) {
      const current = this.blocks[i];
      const next = this.blocks[i + 1];

      if (!next) {
        current.style.setProperty('--opacity', '1');
        continue;
      }

      const nextRect = next.getBoundingClientRect();
      const nextTop = nextRect.top;

      const fadeZone = 0.7; 
      const start = vh;                    
      const end = vh * (1 - fadeZone);     
      const t = (start - nextTop) / (start - end); 

      const lin = Math.min(Math.max(t, 0), 1);

      const eased = lin * lin;
      //const progress = Math.min(Math.max(t, 0), 1);

      const opacity = 1 - eased;
      current.style.setProperty('--opacity', String(opacity));
    }
  }
}
if (!customElements.get('lookbook-section')) {
  customElements.define('lookbook-section', LookbookSection);
}


// SPOTLIGHT COLLECTION
class SpotlightCollection extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.slider = this.querySelector(`.cpb-${this.sectionId}`);
    this._io = null;
    this.spacing = this.dataset.spacing;
    this.autoplay = this.dataset.autoplay;
    this.prev = this.querySelector(`.sc_left-${this.sectionId}`);
    this.next = this.querySelector(`.sc_right-${this.sectionId}`);
    this.dataStyle = this.dataset.collStyle;
    this.mobColumns = this.dataset.mobColumns;
  }

  connectedCallback() {
    if (!this.slider) return;

    const init = () => {
      if (this.swiper) return;

      if (this.dataStyle == 'style1') {
        this.swiper = new Swiper(this.slider, {
          slidesPerView: this.columns,
          spaceBetween: this.spacing,
          speed: 600,
          observer: true,
          observeParents: true,
          autoHeight: true,
          autoplay: this.autoplay === 'true',
          navigation: {
            nextEl: this.next,
            prevEl: this.prev,
          },
          breakpoints: {
            0: {
              slidesPerView: this.mobColumns,
              spaceBetween: this.spacing,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: this.spacing,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: this.spacing,
            },
            991: {
              slidesPerView: 1.2,
              spaceBetween: this.spacing,
            },
            1199: {
              slidesPerView: 2,
              spaceBetween: this.spacing,
            },
            1441: {
              slidesPerView: 3,
              spaceBetween: this.spacing,
            },
          }
        });
      } else {
        this.swiper = new Swiper(this.slider, {
          slidesPerView: this.columns,
          spaceBetween: this.spacing,
          speed: 600,
          observer: true,
          observeParents: true,
          autoHeight: true,
          autoplay: this.autoplay === 'true',
          navigation: {
            nextEl: this.next,
            prevEl: this.prev,
          },
          breakpoints: {
            0: {
              slidesPerView: this.mobColumns,
              spaceBetween: this.spacing,
            },
            640: {
              slidesPerView: 1, // (corrected instead of 1,1)
              spaceBetween: this.spacing,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: this.spacing,
            },
            991: {
              slidesPerView: 2, // (corrected instead of 2,1)
              spaceBetween: this.spacing,
            },
            1199: {
              slidesPerView: 2,
              spaceBetween: this.spacing,
            },
            1441: {
              slidesPerView: 1,
              spaceBetween: this.spacing,
            },
          }
        });
      }
    };

    if (this.slider.offsetWidth === 0) {
      this._io = new IntersectionObserver(([e]) => {
        if (e.isIntersecting) { init(); this._io.disconnect(); }
      }, { threshold: 0.01 });
      this._io.observe(this.slider);
    } else {
      requestAnimationFrame(init);
    }
  }

  disconnectedCallback() {
    this._io?.disconnect();
    this.swiper?.destroy(true, true);
  }
}
customElements.define('spotlight-collection', SpotlightCollection);


// DRAWERS OPEN/CLOSE
const Pointer = document.querySelector(".cursor_pointer");
const openBtns = document.querySelectorAll(".drawer_open_btn");
const closeBtns = document.querySelectorAll(".main_drawer_close");
const drawers = document.querySelectorAll(".main_drawer");

let lastFocusedButton = null;

drawers.forEach((drawer) => {
  const focusableElements = drawer.querySelectorAll("button, input, a, textarea");
  focusableElements.forEach((el) => {
    el.setAttribute("tabindex", "-1");
  });
});

function closeAllDrawers() {
  drawers.forEach((drawer) => {
    drawer.classList.remove("active");
    drawer.setAttribute("aria-hidden", "true");
  });
}

function trapFocus(event, drawer) {
  const focusableElements = drawer.querySelectorAll("button, a, textarea, input:not([type='hidden'])");
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  if (event.key === "Tab") {
    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }
}

function openDrawer(drawer, button) {
  closeAllDrawers();
  if (drawer) {
    lastFocusedButton = button;

    drawer.classList.add("active");
    drawer.setAttribute("aria-hidden", "false");
    document.body.setAttribute("data-scroll-locked", true);
    lenis.stop();

    const focusableElements = drawer.querySelectorAll("button, a, textarea, input:not([type='hidden'])");
    focusableElements.forEach((el) => {
      el.setAttribute("tabindex", "0");
    });

    if (focusableElements.length) {
      focusableElements[0].focus();
    }
    
    drawer.addEventListener("keydown", (event) => trapFocus(event, drawer));  
  }
}

function closeDrawer(drawer) {
  if (drawer) {
    drawer.classList.remove("active");
    drawer.setAttribute("aria-hidden", "true");
    document.body.removeAttribute("data-scroll-locked");
    lenis.start();

    const focusableElements = drawer.querySelectorAll("input, button, a, textarea");
    focusableElements.forEach((el) => {
      el.setAttribute("tabindex", "-1");
    });

    if (lastFocusedButton) {
      lastFocusedButton.focus();
      lastFocusedButton = null;
    }
  }
}

openBtns.forEach((button) => {
  button.addEventListener("click", async (event) => {
    event.preventDefault();
    const drawerId = button.getAttribute("data-drawer");
    const drawer = document.getElementById(drawerId);

    if(drawer.classList.contains('mobile_drawer_wrapper')) {
      document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '2';
      //document.querySelector('.shopify-section-group-header-group.announcement-bar').style.zIndex = '2';
      const announcementBar = document.querySelector('.shopify-section-group-header-group.announcement-bar');
if (announcementBar) announcementBar.style.zIndex = '2';
    } else {
      document.querySelectorAll('.shopify-section').forEach((section) => {
        section.style.zIndex = '0';
        if(section.classList.contains('main-collection-section')) {
          section.style.zIndex = '0'
        }
      })
      document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '0';
      const announcementBar = document.querySelector('.shopify-section-group-header-group.announcement-bar');
if (announcementBar) announcementBar.style.zIndex = '0';
     
    }

    if(drawer.classList.contains('pickup_availability_drawer')) {
      drawer.closest('.shopify-section').style.zIndex = '1'
    }
    
    openDrawer(drawer, button);
  });
});

closeBtns.forEach((button) => {
  button.addEventListener("click", () => {
    const drawer = button.closest(".main_drawer");    
    document.querySelectorAll('.shopify-section').forEach((section) => {
        section.style.zIndex = '0';
        if(section.classList.contains('main-product-section')) {
          section.style.zIndex = '1';
        }
      })
    document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '4';
    //document.querySelector('.shopify-section-group-header-group.announcement-bar').style.zIndex = '4';
    const announcementBarClose = document.querySelector('.shopify-section-group-header-group.announcement-bar');
if (announcementBarClose) announcementBarClose.style.zIndex = '4';
    closeDrawer(drawer);
  });
});

drawers.forEach((drawer) => {
  drawer.addEventListener("click", (event) => {
    if (event.target === drawer) {      
      document.querySelectorAll('.shopify-section').forEach((section) => {
        section.style.zIndex = '0';
        if(section.classList.contains('main-product-section')) {
          section.style.zIndex = '1';
        }
      })
      document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '4';
const announcementBarClose = document.querySelector('.shopify-section-group-header-group.announcement-bar');
if (announcementBarClose) announcementBarClose.style.zIndex = '4';

      closeDrawer(drawer);
    }
  });

  drawer.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {    
    document.querySelectorAll('.shopify-section').forEach((section) => {
        section.style.zIndex = '0';
        if(section.classList.contains('main-product-section')) {
          section.style.zIndex = '1';
        }
      })
    document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '4';
    document.querySelector('.shopify-section-group-header-group.announcement-bar').style.zIndex = '4';  
    
    closeDrawer(drawer);
    }
  });

  drawer.addEventListener("mouseenter", () => Pointer.classList.add("close"));
  drawer.addEventListener("mouseleave", () =>
    Pointer.classList.remove("close")
  );

  const Inner = drawer.querySelector(".main_drawer_inner");

  Inner.addEventListener("mouseenter", () => Pointer.classList.remove("close"));
  Inner.addEventListener("mouseleave", () => Pointer.classList.add("close"));
});


// LOCALIZATION
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    let input = this.querySelector(
      'input[name="language_code"], input[name="country_code"]'
    );
    let listItems = this.querySelectorAll(".country_selector_ul li");
    let form = this.querySelector("form");
    listItems.forEach(function (listItem) {
      listItem.addEventListener("click", function (event) {
        event.preventDefault();
        let value = listItem.getAttribute("data-value");
        input.value = value;
        if (form) form.submit();
      });
    });
  }
}

customElements.define("localization-form", LocalizationForm);

window.addEventListener("scroll", () => {
  document.dispatchEvent(new Event("theme:scroll"));
});

window.addEventListener("resize", () => {
  document.dispatchEvent(new Event("theme:resize"));
});


// CART DRAWER
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.loader = this.querySelector('.loader_wrapper');
  }

  connectedCallback() {
    document.addEventListener('cart-update', this.cartUpdate.bind(this));

    this.loadInitialUpsells();
  }

  loadInitialUpsells() {
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(cart => {
        if (!cart || !cart.items || !cart.items.length) return;

        this.loadUpsellProducts(cart);
      })
      .catch(err => console.error('Initial upsell load error:', err));
  }

  cartUpdate(e) {
    // CART DRAWER UPDATE
    let tempDiv = document.createElement('div');
    let newDrawer = e.detail.sections['cart-drawer'];
    let error = e.detail.message;
    let button = e.detail.button;
    
    if(newDrawer) {
      tempDiv.innerHTML = newDrawer;
    }
    let cartDrawer = document.querySelector('.cart_drawer_inner');
    if(cartDrawer) {
      cartDrawer.innerHTML = tempDiv.querySelector('.cart_drawer_inner').innerHTML;  

      if (e.detail) {
        const payload = e.detail.cart ?? e.detail;
        this.loadUpsellProducts(payload);
      }

      if(error && e.detail.line) {
        const lineWrapper = cartDrawer.querySelector(`quantity-wrapper[data-line="${e.detail.line}"]`);
        if(lineWrapper) {
          lineWrapper.querySelector('.cart_quantity_error').textContent = error;
          lineWrapper.querySelector('.cart_quantity_error').classList.remove('hidden');
        }        
      }
    }

    // CART COUNT UPDATE
    let temp = document.createElement('div');
    let newCount = e.detail.sections['cart-count'];
    if(newCount) {
      temp.innerHTML = newCount;
    }

    document.querySelector('.cart-count-text').innerHTML = temp.querySelector('.cart-count-text').innerHTML;

    const drawer = document.querySelector('.cart_drawer_wrapper');    
    if(drawer && button) {    
      document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '0';
      document.querySelector('.shopify-section-group-header-group.announcement-bar').style.zIndex = '0';
      const productWrapper = document.querySelector('.shopify-section.main-product-section');
      if(productWrapper) {
        productWrapper.style.zIndex = '0'
      }
      openDrawer(drawer,button)
    }      
    
    if(drawer) {
      const closeBtn = drawer.querySelector('.main_drawer_close');
      if(!closeBtn) return;
      closeBtn.addEventListener('click', () => {
        document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '4';
        document.querySelector('.shopify-section-group-header-group.announcement-bar').style.zIndex = '4';
      });
    }
  }

 initUpsellSwiper() {
  const slider = this.querySelector('.cart_upsell_items.swiper');
  if (!slider) return;

  // Register module (safe to call multiple times)
  if (Swiper?.use) {
    Swiper.use([Swiper.Navigation]);
  }

  // Destroy previous instance
  if (slider.swiper) {
    slider.swiper.destroy(true, true);
  }

  const prevBtn = slider.querySelector('.cu.swiper-button-prev');
  const nextBtn = slider.querySelector('.cu.swiper-button-next');

  new Swiper(slider, {
    slidesPerView: 2,
    spaceBetween: 10,
    loop: false,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    navigation: {
      prevEl: prevBtn,
      nextEl: nextBtn,
    },
    breakpoints: {
        0: { slidesPerView: 2.5 },
        768: { slidesPerView: 2.5 },
        1024: { slidesPerView: 2.5 }
      }
    });
  }

  loadUpsellProducts(cart) {
    if (!cart || !cart.items || !cart.items.length) return;

    const firstItem = cart.items[0];
    if (!firstItem?.product_id) return;

    const upsellWrapper = this.querySelector('.cart_drawer_upsell_products');
    if (!upsellWrapper) return;

    fetch(
      `/recommendations/products?product_id=${firstItem.product_id}&limit=10&section_id=cart-upsell`
    )
      .then(res => res.text())
      .then(html => {
        const temp = document.createElement('div');
        temp.innerHTML = html;

        upsellWrapper.innerHTML = temp.innerHTML;

        this.initUpsellSwiper();
      })
      .catch(err => console.error('Upsell error:', err));
  }

}

customElements.define('cart-drawer', CartDrawer);


// MAIN CART PAGE
class MainCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener('cart-update', this.handleCartPageUpdate.bind(this));
  }

  handleCartPageUpdate(e) {

    // MAIN CART PAGE UPDATE
    const tempCart = document.createElement('div');
    const newCart = e.detail.sections['main-cart'];
    let error = e.detail.message;
   
    if(newCart) {
      tempCart.innerHTML = newCart;
    }


    const oldCart = document.querySelector('main-cart');
    if(oldCart) {
      oldCart.querySelector('.main_cart_inner').innerHTML = tempCart.querySelector('.main_cart_inner').innerHTML;
      if(error && e.detail.line) {
        const lineWrapper = oldCart.querySelector(`quantity-wrapper[data-line="${e.detail.line}"]`);
        if(lineWrapper) {
          lineWrapper.querySelector('.cart_quantity_error').textContent = error;
          lineWrapper.querySelector('.cart_quantity_error').classList.remove('hidden');
        }        
      }
    }

    // CART COUNT UPDATE
    let temp = document.createElement('div');
    let newCount = e.detail.sections['cart-count'];
    if(newCount) {
      temp.innerHTML = newCount;
    }

    document.querySelector('.cart-count-text').innerHTML = temp.querySelector('.cart-count-text').innerHTML;     
  }
}

customElements.define('main-cart', MainCart);


// CART REMOVE
class CartRemove extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('a');
    this.line = this.dataset.line;
    this.wrapper = this.closest('cart-drawer') || this.closest('main-cart');
    this.loader = this.wrapper.querySelector?.('.loader_wrapper');
  }

  connectedCallback() {
    this.link.addEventListener('click', this.handleRemove.bind(this));
  }

  handleRemove(e) {
    e.preventDefault();
    if(this.loader) {
      this.loader.classList.add('active');
    }

    const formData = {
      'line': this.line,
      'quantity': e.currentTarget.dataset.quantity,
      'sections': 'cart-drawer,cart-count,main-cart'
    }


    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: data,
          bubbles: true
        })
      )
    })
  }
}

customElements.define('cart-remove', CartRemove);


// QUANTITY WRAPPER
class QuantityWrapper extends HTMLElement {
  constructor() {
    super();
    this.minusBtn = this.querySelector('[data-minus]');
    this.plusBtn = this.querySelector('[data-plus]');
    this.input = this.querySelector('input');   
    this.line = this.dataset.line; 
    this.wrapper = this.closest('cart-drawer') || this.closest('main-cart');
    this.loader = this.wrapper.querySelector('.loader_wrapper');
    this.step = Number(this.input.getAttribute('step'));
    this.max = Number(this.input.getAttribute('max'));
    this.min = Number(this.input.getAttribute('min'));
  }

  connectedCallback() {
    this.plusBtn.addEventListener('click', this.handleChange.bind(this));
    this.minusBtn.addEventListener('click', this.handleChange.bind(this));
    const debouncedHandler = this._debounce((e) => this.handleInput(e), 1000)
    this.input.addEventListener('input', debouncedHandler);
  }

  getValue(e) {    
    if(e.currentTarget.hasAttribute('data-plus')) {
      let value = parseInt(this.input.value);
      value = value + this.step;
      if(this.min) {
        if(value <= this.min) {
          this.minusBtn.setAttribute('disabled', '');
        } else {
          this.minusBtn.removeAttribute('disabled');
        }
      } else {
        if(value == 1) {
          this.minusBtn.setAttribute('disabled', '');
        } else {
          this.minusBtn.removeAttribute('disabled');
        }
      }
      
      this.input.value = value;
      return value;
    } else {
      let value = parseInt(this.input.value);
      value = value - this.step;
      if(this.min) {
        if(value <= this.min) {
          this.minusBtn.setAttribute('disabled', '');
        } else {
          this.minusBtn.removeAttribute('disabled');
        }
      } else {
        if(value == 1) {
          this.minusBtn.setAttribute('disabled', '');
        } else {
          this.minusBtn.removeAttribute('disabled');
        }
      }

      this.input.value = value;
      return value;
    }
  }

  handleChange(e) {
    e.preventDefault();
    let value = this.getValue(e);
    
    if(this.loader) {
      this.loader.classList.add('active');
    }

    const formData = {
      'line': this.line,
      'quantity': value,
      'sections': 'cart-drawer,cart-count,main-cart'
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(async (res) => {
      const data = await res.json();

      if(!res.ok) {        
        const rawCartData = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-count,main-cart').then((res) => res.json());        
        const cartData = {
          'line': this.line,
          'message': data.message || data.description,
          'sections': rawCartData,          
        }

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        )
        throw new Error(data.description || data.message || 'Request failed');        
      }

      return data;
    })
    .then((cartData) => {          
      document.documentElement.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: cartData,          
          bubbles: true
        })
      )
    })
  }

  handleInput(e) {
    e.preventDefault();

    if(this.loader) {
      this.loader.classList.add('active');
    }

    const formData = {
      'line': this.line,
      'quantity': e.target.value,
      'sections': 'cart-drawer,cart-count,main-cart'
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(async (res) => {
      const data = await res.json();

      if(!res.ok) {        
        const rawCartData = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-count,main-cart').then((res) => res.json());        
        const cartData = {
          'line': this.line,
          'message': data.message || data.description,
          'sections': rawCartData
        }

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        )
        throw new Error(data.description || data.message || 'Request failed');        
      }

      return data;
    })
    .then((cartData) => {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: cartData,
          bubbles: true
        })
      )
    })
  }

  _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('quantity-wrapper', QuantityWrapper);


// CART DRAWER CLOSE
class CartDrawerClose extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector('.main_drawer_close');
    this.drawer = this.closest('.cart_drawer_wrapper');
  }

  connectedCallback() {
    this.closeBtn.addEventListener('click', this.handleClose.bind(this));
  }

  handleClose() {
    document.querySelectorAll('.shopify-section:not(.header-section):not(.announcement-bar)').forEach((section) => {
      section.style.zIndex = '0';
      if(section.classList.contains('main-product-section')) {
        section.style.zIndex = '1';
      }
    })
    closeDrawer(this.drawer);
  }
}

customElements.define('cart-drawer-close', CartDrawerClose);


// CART DRAWER NOTE
class CartNote extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.cart_note_trigger');
    this.wrapper = this.querySelector('.cart_note_wrapper');
    this.close = this.querySelector('.cart_note_close');
    this.wrapperInner = this.wrapper.querySelector('.cart_note_inner');
    this.add_note = this.querySelector('.cart_add_note');
    this.edit_note = this.querySelector('.cart_edit_note');
    this.textarea = this.querySelector('textarea');
    this.cursor = document.querySelector('.cursor_pointer');
  }

  connectedCallback() {
    this.close.querySelector('button').setAttribute('tabindex', '-1');
    this.textarea.setAttribute('tabindex', '-1');
    this.trigger.addEventListener('click', this.openCartNote.bind(this));
    this.close.addEventListener('click', this.closeCartNote.bind(this));
    this.wrapper.addEventListener('click', this.closeCartNote.bind(this));
    this.wrapperInner.addEventListener('click', (e) => {
      e.stopPropagation();
    })

    this.trigger.querySelector('button').addEventListener('focusin', (e) => {
      const el = e.target;
      if(el.matches(':focus-visible')) {
        this.wrapper.classList.add('active');
        this.textarea.setAttribute('tabindex', '0');
        this.close.querySelector('button').setAttribute('tabindex', '0');
        setTimeout(() => {
          this.close.querySelector('button').focus();
        }, 10);
      }
    })

    this.textarea.addEventListener('blur', () => {
      this.wrapper.classList.remove('active');
      this.textarea.setAttribute('tabindex', '-1');
      this.close.querySelector('button').setAttribute('tabindex', '-1');
    })
  }

  openCartNote() {
    this.wrapper.classList.add('active');

    if(this.wrapper.classList.contains('is_cart_page')) {
      this.closest('main-cart').classList.add('above');
      document.body.setAttribute("data-scroll-locked", true);
      lenis.stop();
    }
  }

  closeCartNote() {
    this.checkTextarea();
    this.wrapper.classList.remove('active');

    if(this.wrapper.classList.contains('is_cart_page')) {
      this.closest('main-cart').classList.remove('above');
      this.cursor.classList.remove('close');
      document.body.removeAttribute("data-scroll-locked");
      lenis.start();
    }
  }

  checkTextarea() {
    if(this.textarea.value.trim() === '') {
      this.add_note.style.display = 'block';
      this.edit_note.style.display = 'none';
    } else {
      this.edit_note.style.display = 'block';
      this.add_note.style.display = 'none';
    }
  }
}

customElements.define('cart-note', CartNote);


// CART DISCOUNT
class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="discount"]');
        this.inputValue = this.input.value;
        this.remove = this.querySelector('[data-discount-remove]');
        this.error = this.querySelector('.cart_discount_error');
        this.wrapper = this.closest('cart-drawer') || this.closest('main-cart');
        this.loader = this.wrapper.querySelector('.loader_wrapper');
  }

  connectedCallback() {
        this.input.addEventListener('input', this.handleInput.bind(this));
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        if(this.remove) {
            this.remove.addEventListener('click', this.handleRemove.bind(this));
        }
    }

    handleInput(e) {
        e.preventDefault();
        this.inputValue = this.input.value;
    }

    handleFormSubmit(e) {
      e.preventDefault();

      if(this.loader) {
        this.loader.classList.add('active');
      }

      const formData = {
        discount: this.inputValue,
        sections: 'cart-drawer,cart-count,main-cart'
      }

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': "application/json"
        },
        body: JSON.stringify(formData)
      })
      .then((res) => res.json())
      .then((cartData) => {
        if(cartData.discount_codes[0].applicable == false) {
          if(this.error) {
            this.error.classList.remove('hidden');
            this.input.value = "";
          } 

          if(this.loader) {
           this.loader.classList.remove('active');
          }
        } else {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart-update', {
              detail: cartData,
              bubbles: true
            })
          )
        }
      })
    }

    handleRemove(e) {
      e.preventDefault();

      if(this.loader) {
        this.loader.classList.add('active');      
      }  

      const formData = {
        discount: "",
        sections: "cart-drawer,cart-count,main-cart"
      }

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': "application/json",
        },
        body: JSON.stringify(formData)
      })
      .then((res) => res.json())
      .then((cartData) => {
        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        )
      })
    }
}

customElements.define('cart-discount', CartDiscount);


// VARIANT PICKER
class VariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (e) => {
      const target = e.target.tagName === 'SELECT' ? e.target.selectedOptions[0] : e.target;

      this.closest('product-info').dispatchEvent(
        new CustomEvent('variant-change', {
          detail: {
            target: target,
            selectedOptionValues: this.selectedOptionValues
          }
        })
      )
    })
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], input:checked")
    ).map(({ dataset }) => dataset.valueId);
  }
}

customElements.define('variant-picker', VariantPicker);


// PRODUCT INFO
class ProductInfo extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;     
    this.originalSectionId = this.dataset.originalSectionId;
    this.productUrl = this.dataset.productUrl;  
    this.updateUrl = this.dataset.updateUrl;
    this.isMainProduct = this.dataset.mainProduct;
    this._onVariantChange = this._onVariantChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener('variant-change', this._onVariantChange);
  }

  disconnectedCallback() {
    this.removeEventListener('variant-change', this._onVariantChange);
  }

  _onVariantChange(e) {
    const target = e?.detail?.target?.tagName;
    const optionValues = e?.detail?.selectedOptionValues || [];

    const url = this.buildUrl(this.sectionId, this.productUrl, optionValues);
    this.handleUpdate(url);   
    document.dispatchEvent(
      new CustomEvent('pickup:check', {
        bubbles: true
      })
    ) 
  }

  buildUrl(sectionId, productUrl, values) {
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('option_values', values.join(','));

    if(this.isMainProduct != 'true') {
      url.searchParams.set('section_id', this.sectionId);  
    }
    
    return url.toString(); 
  }

  handleUpdate(url) {
    fetch(url)
    .then((res) => res.text())
    .then((data) => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = data;      

      const originalSectionId = this.originalSectionId;
      if(this.sectionId.includes('quick-add')) {
        const updatedSectionId = `quick-add-${originalSectionId}`;
        tempDiv.innerHTML = tempDiv.innerHTML.replaceAll(originalSectionId, updatedSectionId);
      }      

      tempDiv.querySelector('product-info').dataset.updateUrl = this.updateUrl;
      tempDiv.querySelector('product-info').dataset.sectionId = this.sectionId;
      
      if(tempDiv) {
        document.querySelector(`product-info[data-section-id="${this.sectionId}"]`).innerHTML = tempDiv.querySelector(`product-info[data-section-id="${this.sectionId}"]`).innerHTML;
      }

      const selectedVariant = tempDiv.querySelector('script[data-selected-variant]');

      if(this.updateUrl == 'true') {
        this.handleUpdateUrl(selectedVariant);
      } 
      
    })
  }

  handleUpdateUrl(variant) {
    const selectedVariant = JSON.parse(variant.textContent);
    const id = selectedVariant.id;

    const url = new URL(window.location.href)
    url.searchParams.delete('variant');
    url.searchParams.set('variant', id);

    window.history.replaceState({}, '', url.toString());  

    this.handlePickup(id);
  } 
  
  handlePickup(id) {
     let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }

    fetch(`${rootUrl}variants/${id}/?section_id=pickup-availability-section`)
    .then((res) => res.text())
    .then((data) => {
      const container = document.querySelector('[data-store-availability-container]');
      const pickupHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.pa_wrapper');

      if(container && pickupHTML) {
        container.innerHTML = pickupHTML.innerHTML;
        const drawer = container.querySelector('pickup-availability-drawer');
        const btn = container.querySelector('.pickup_availability_information_btn');
        const cursor = document.querySelector('.cursor_pointer');

        if(cursor && drawer) {
          drawer.addEventListener('mouseenter', () => {
            cursor.classList.add('close');
          })

          drawer.addEventListener('mouseleave', () => {
            cursor.classList.remove('close');
          })

          drawer.querySelector('.main_drawer_inner').addEventListener('mouseenter', () => {
            cursor.classList.remove('close')
          })

          drawer.querySelector('.main_drawer_inner').addEventListener('mouseleave', () => {
            cursor.classList.add('close')
          })
        }

        if(drawer && btn) {
          btn.addEventListener('click', () => {
            document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '0';
            document.querySelector('.shopify-section-group-header-group.announcement-bar').style.zIndex = '0';
            openDrawer(drawer, btn);
          })
        }

        if(drawer) {
          drawer.addEventListener('click', () => {
            document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '0';
            document.querySelector('.shopify-section-group-header-group.announcement-bar').style.zIndex = '0';
            closeDrawer(drawer)
          })
        }
      }     

      
    })
    .catch((e) => {
      console.error('Error: ', e)
    })
  }
}

customElements.define('product-info', ProductInfo);


// PRODUCT QUANTITY
class ProductQuantityWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.minus = this.querySelector('[data-minus]');
    this.plus = this.querySelector('[data-plus]');
    this.input = this.querySelector('input[name="product_quantity"]');
    this.value = this.input.value;
    this.step = Number(this.input.getAttribute('step'));
    this.min = Number(this.input.getAttribute('min'));
    this.max = Number(this.input.getAttribute('max'));

    this.plus.addEventListener('click', this.handleChange.bind(this));
    this.minus.addEventListener('click', this.handleChange.bind(this));
    const debouncedHandler = this._debounce((e) => this.handleInput(e), 1000);
    this.input.addEventListener('input', debouncedHandler);
  }

  handleChange(e) {
    let attr = e.currentTarget.dataset.action;
    if(attr == 'plus') {
      this.value = parseInt(this.value) + this.step;      
    }  else {
      this.value = parseInt(this.value) - this.step;
    }

    if(this.min) {
      if(this.value > this.min) {
        this.minus.removeAttribute('disabled');
      } else {
        this.minus.setAttribute('disabled', '');
      }
    } else {
      if(this.value > 1) {
      this.minus.removeAttribute('disabled');
      } else {
        this.minus.setAttribute('disabled', '');
      }
    }

    if(this.max) {
      if(this.value >= this.max) {
        this.plus.setAttribute('disabled', '');
      } else {
        this.plus.removeAttribute('disabled');
      }
    }

    

    this.input.value = this.value;
    this.closest('product-info').querySelector('input[name="quantity"]').value = this.value;
  }

  handleInput(e) {
    let value = e.target.value;
    value = parseInt(value)

    if(value == 0 || isNaN(value)) {
      value = 1;
    }
    this.value = value;

    if(this.value > 1) {
      this.minus.removeAttribute('disabled');
    } else {
      this.minus.setAttribute('disabled', '');
    }

    this.input.value = this.value;
    const mainInput = this.closest('product-info').querySelector('input[name="quantity"]');
    if(mainInput) {
      mainInput.value = this.value;
    }

  }

   _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('product-quantity-wrapper', ProductQuantityWrapper);


// PRODUCT FORM
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form.product_form');
    this.button = this.querySelector('.add_to_cart_button');
    this.icon = this.button.querySelector('.icon_wrapper') || this.button.querySelector('.atc_text');
    this.mainInput = this.querySelector('input[name="id"]');
    this.cart = document.querySelector('cart-drawer');
    this.loader = this.button.querySelector('.form_loader');
    this.info = this.closest('product-info');
    if(this.info) {
      this.giftWrap = this.info.querySelector('#product_gift_wrapp');
    }
  }

  connectedCallback() {
  if(this.form) {
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
      }
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.icon.classList.add('hidden');
    if(this.icon && this.loader) {
      this.icon.classList.add('hidden');
      this.loader.classList.remove('hidden');
    } 

    const formData = new FormData(this.form);
    const payload = {};
    for (const [key, value] of formData.entries()) {
    // Detect line item properties
    const propertyMatch = key.match(/^properties\[(.+)\]$/);
    if (propertyMatch) {
      if (!payload.properties) payload.properties = {};
      payload.properties[propertyMatch[1]] = value;
    } else {
      payload[key] = value;
    }
  }
   // const payload = Object.fromEntries(formData.entries());

   const items = [payload];
   
   if(this.giftWrap && this.giftWrap.checked) {
    const giftWrapId = this.giftWrap.value;
    items.push({
      id: giftWrapId,
      quantity: 1,
      parent_id: this.mainInput.value,
      properties: {
        for: `${this.mainInput.dataset.title} (${this.mainInput.dataset.variantTitle})`
      }
    })
   }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items })
    })
    .then(async (res) =>{
      const data = await res.json();
      if(!res.ok) {
        let message = '';

        if(data.errors) {         
          Object.entries(data.errors).forEach(([field, messages]) => {
          if(Object.keys(data.errors).length > 1) {
              message += `<div>${messages[0]}</div>`            
          } else {
            message = messages[0]
          }
        });          
        } else if(data.description) {
          message = data.description;
        } else if(data.message) {
          message = data.message;
        }

        const errorWrapper = this.querySelector('.product_card_cart_error');
        const error = this.closest('product-info');
        
        if(errorWrapper) {
          errorWrapper.innerHTML = message;
          errorWrapper.classList.add('show');

          setTimeout(() => {
            errorWrapper.classList.remove('show');
          }, 2000)
        }      
        
        if(error) {          
          error.querySelector('.product_quantity_error').innerHTML = message;
          error.querySelector('.product_quantity_error').classList.remove('hidden');
        }

        const rawCartData = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-count,main-cart').then((res) => res.json());        
      const cartData = {          
          'sections': rawCartData,
          'message': message,          
        }

      document.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: cartData,
          bubbles: true
        })
      )

        throw new Error(data.description || 'Error add to cart');
      }
      return data;
    })
    .then(async (data) => {
      if(this.cart) {
        const rawCartData = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-count,main-cart').then((res) => res.json());     
        
        const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(res => res.json());

        const cartData = {
            'cart': cart,
            'sections': rawCartData,
            'button': this.button
          }

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        )
      } else {
        window.location.href = window.Shopify.routes.root + 'cart'
      }
    })
    .finally(() => {
      this.icon.classList.remove('hidden');
      this.loader.classList.add('hidden')
    })
  }
}

customElements.define('product-form', ProductForm);


// PRODUCT DESCRIPTION
class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.inner = this.querySelector('.pd');
    this.innerWrapper = this.querySelector('.product_description_inner');
    this.readMore = this.querySelector('.read_more');
  }

  connectedCallback() {
    if(this.inner) {
      this.height = this.inner.clientHeight;
      this.innerWrapper.style.setProperty('--max-height', `${this.height}px`)
    }
    
    if(this.readMore) {
      this.readMore.addEventListener('click', this.handleClick.bind(this));
    }
  }

  handleClick(e) {
    e.preventDefault();
    if(this.innerWrapper.hasAttribute('open')) {
      this.innerWrapper.removeAttribute('open');
      this.readMore.querySelector('.rm').style.display = 'block';
      this.readMore.querySelector('.rl').style.display = 'none';
    } else {
      this.innerWrapper.setAttribute('open', '');
      this.readMore.querySelector('.rm').style.display = 'none';
      this.readMore.querySelector('.rl').style.display = 'block';
    }
  }
}

customElements.define('product-description', ProductDescription);


// PRODUCT MEDIA SLIDER
class ProductMediaSlider extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;
    this.slider = this.querySelector(`.fp-${this.sectionId}.swiper`);
    this.thumbSlider = this.querySelector(
      `.product_main_thumbnails_media_wrapper-${this.sectionId}`
    );
    this.prev = this.querySelector('.prev_arrow');
    this.next = this.querySelector('.next_arrow');

    this.swiper = null;
    this.thumbnailSwiper = null;   

    this.models = this.querySelectorAll('product-model'); 
  }

  connectedCallback() {
    if (!this.slider) return;

    this.init();

    this._resizeHandler = this.handleResize.bind(this);
    window.addEventListener('resize', this._resizeHandler); 
    
    this.models.forEach((model) => {  
      model.addEventListener('mouseenter', () => {  
        if (this.swiper) this.swiper.allowTouchMove = false;
      })

      model.addEventListener('mouseleave', () => {        
        if (this.swiper) this.swiper.allowTouchMove = true;
      })
    });
  }

  handleResize() {
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;

    if (isDesktop) {
      this.swiper?.update();
      //this.swiper?.updateAutoHeight();
    }
  }

  init() {
    if (this.swiper) return;

    if (this.thumbSlider) {
      this.thumbnailSwiper = new Swiper(this.thumbSlider, {
        slidesPerView: 6,
        spaceBetween: 10,
        speed: 600,
        watchSlidesProgress: true,
        breakpoints: {
          0: {
            slidesPerView: 5
          },
          769: {
            slidesPerView: 4
          },
          1025: {
            slidesPerView: 5
          },
          1299: {
            slidesPerView: 6
          }
        }
      });
    }

    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 600,
      autoHeight: false,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: this.next,
        prevEl: this.prev,
      },

      thumbs: this.thumbnailSwiper
        ? { swiper: this.thumbnailSwiper }
        : undefined,
    });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._resizeHandler);
    
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    if (this.thumbnailSwiper) {
      this.thumbnailSwiper.destroy(true, true);
      this.thumbnailSwiper = null;
    }
  }  
}

customElements.define('product-media-slider', ProductMediaSlider);


// PRODUCT MOBILE MEDIA
class ProductMobileMedia extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.mainSlider = this.querySelector(`.product_mobile_main_media_wrapper-${this.sectionId}`);     
    this.thumbnailSlider = this.querySelector(`.product_mobile_thumbnails_media_wrapper-${this.sectionId}`);
    this.spacing = this.dataset.spacing;

    this.videos = this.querySelectorAll('video');
    this.youtubeIframes = this.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
    this.vimeoIframes = this.querySelectorAll('iframe[src*="vimeo.com"]');
    this.models = this.querySelectorAll('product-model'); 
  }

  connectedCallback() {
    if(!this.mainSlider) return; 
    
    if(!this.mainSlider || !this.thumbnailSlider ) return;

    if (this.swiper) this.swiper.destroy(true, true);
    if (this.thumbnailSwiper) this.thumbnailSwiper.destroy(true, true);
    
    
    this.thumbnailSwiper = new Swiper(this.thumbnailSlider, {
      slidesPerView: 4,      
      spaceBetween: 5,
      speed: 600,
      watchSlidesProgress: true,
    }); 

    this.swiper = new Swiper(this.mainSlider, {
      slidesPerView: 1,      
      spaceBetween: this.spacing,
      speed: 600,
      observeParents: true,
      autoHeight: true,
      nested: false,
      navigation: {
        nextEl: '.product_mobile_media_next',
        prevEl: '.product_mobile_media_prev',
      },
      thumbs: {
        swiper: this.thumbnailSwiper,
      },       
    });    

         
      // HTML5 <video>
      this.videos.forEach((video) => {
        video.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleVideoClick(video)         
        });

         video.addEventListener('touchstart', () => {
          this.handleVideoClick(video);
        });
      });

      // YouTube <iframe>
      this.youtubeIframes.forEach((iframe) => {
        iframe.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleYoutubeClick(iframe)
        });

        iframe.addEventListener('touchstart', (e) => {
          this.handleYoutubeClick(iframe)
        });
      });

      // Vimeo <iframe>
      this.vimeoIframes.forEach((iframe) => {
        iframe.addEventListener('touchstart', () => this.handleVimeoClick(iframe));
        iframe.addEventListener('click', () => this.handleVimeoClick(iframe));
      });

      // Product model
      this.models.forEach((model) => {  
        model.addEventListener('mouseenter', () => {  
          lenis.stop();     
          document.documentElement.style.overflow = 'auto';
          if (this.swiper) this.swiper.allowTouchMove = false;
        })

        model.addEventListener('mouseleave', () => {        
          lenis.start();
          document.documentElement.style.overflow = 'unset';
          if (this.swiper) this.swiper.allowTouchMove = true;
        })
        model.addEventListener('click', (e) => this.handleModelClick(model));      
      });
  }

  // Handle native video
  handleVideoClick(currentVideo) {
    this.pauseAll(currentVideo);
    currentVideo.previousElementSibling.classList.add('fade');

    if(currentVideo.paused) {
      currentVideo.play();
    } else {
      currentVideo.pause();
    }
  }

  // Handle YouTube iframe
  handleYoutubeClick(currentIframe) {
    this.pauseAll(currentIframe);
    currentIframe.contentWindow.postMessage(
      JSON.stringify({ event: "command", func: "playVideo", args: [] }),
      "*"
    );
  }

  // Handle Vimeo iframe
  handleVimeoClick(currentIframe) {
    this.pauseAll(currentIframe);
    currentIframe.contentWindow.postMessage(
      { method: "play" },
      "*"
    );
  }

  handleModelClick(currentModel) {
    this.pauseAll(currentModel);
  }

  // Pause everything except the current
  pauseAll(except = null) {
    // HTML5 video
    this.videos.forEach((v) => {
      if (v !== except) {
        v.previousElementSibling.classList.remove('fade');
        v.pause();
      }
    });

    // YouTube
    this.youtubeIframes.forEach((iframe) => {
      if (iframe !== except) {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: "command", func: "pauseVideo", args: [] }),
          "*"
        );
      }
    });

    // Vimeo
    this.vimeoIframes.forEach((iframe) => {
      if (iframe !== except) {
        iframe.contentWindow.postMessage({ method: "pause" }, "*");
      }
    });

    this.models.forEach((model) => {
      if(model !== except) {
        if (model.modelViewerUI) {
          model.modelViewerUI.pause();
        } 
      }
    })
  }
}

customElements.define('product-mobile-media', ProductMobileMedia);


// COLLECTION FILTERS
class CollectionFilters extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    this.inputs = this.querySelectorAll('input[type="checkbox"]');
    this.range = this.querySelectorAll('input[type="range"]');
    this.activeFilters = this.querySelectorAll('.active_filter');
    this.selects = this.querySelectorAll('select');
    this.sectionId = this.dataset.sectionId;    
    this.minRange = this.querySelector('input[type="range"][data-min-value]');
    this.maxRange = this.querySelector('input[type="range"][data-max-value]');
    this.minPlaceholder = this.querySelector('.min_placeholder');
    this.maxPlaceholder = this.querySelector('.max_placeholder');
    this.mainCollection = this.closest('main-collection');
    this.mainSearch = this.closest('main-search');

    this.loader = this.mainCollection?.querySelector('.for_desktop.loader_wrapper') || this.mainSearch?.querySelector('.for_desktop.loader_wrapper');

    this.range.forEach((range) => {
      range.addEventListener('input', (e) => {
        this.loader.classList.add('active');
        this.handleRangeChange(e)
      });
    })

    this.inputs.forEach((input) => {
      input.addEventListener('change', (e) => {
        this.loader.classList.add('active')
        const url = e.currentTarget.checked
          ? new URL(e.currentTarget.dataset.addUrl, window.location.origin)
          : new URL(e.currentTarget.dataset.removeUrl, window.location.origin);

        url.searchParams.set('sections', this.sectionId);
        document.dispatchEvent(new CustomEvent('collection-page-update', {
          detail: { url, sectionId: this.sectionId },
          bubbles: true
        }));
        this.updateURL(url);
      });

      if(input.hasAttribute('disabled')) return;
      const label = input.nextElementSibling;
      label.addEventListener('click', () => {
        this.loader.classList.add('active');
      })
    });

    this.range.forEach((range) => {
      range.addEventListener('change', (e) => {
        this.loader.classList.add('active');
       // this.handleRangeChange(e)
        const url = new URL(location.href);

        url.searchParams.delete(this.minRange.dataset.param);
        url.searchParams.delete(this.maxRange.dataset.param);
        url.searchParams.set(this.minRange.dataset.param, this.minRange.value);
        url.searchParams.set(this.maxRange.dataset.param, this.maxRange.value);

        url.searchParams.set('sections', this.sectionId);
        document.dispatchEvent(new CustomEvent('collection-page-update', {
          detail: { url, sectionId: this.sectionId },
          bubbles: true
        }));
        this.updateURL(url);
      })           
    });

    this.activeFilters.forEach((activeFilter) => {
      activeFilter.addEventListener('click', (e) => {        
        e.preventDefault();
        this.loader.classList.add('active');
        const url = new URL(e.currentTarget.href, window.location.origin);
        url.searchParams.set('sections', this.sectionId);
        document.dispatchEvent(new CustomEvent('collection-page-update', {
          detail: { url, sectionId: this.sectionId },
          bubbles: true
        }));
        this.updateURL(url);
      });
    });

    this.selects.forEach((select) => {
      select.addEventListener('change', (e) => {
        e.preventDefault();
        this.loader.classList.add('active');
        const value = select.value;
        const url = new URL(window.location.href, window.location.origin);
        url.searchParams.set('sort_by', value);
        url.searchParams.set('sections', this.sectionId);
        document.dispatchEvent(new CustomEvent('collection-page-update', {
          detail: { url, sectionId: this.sectionId },
          bubbles: true
        }));
        this.updateURL(url);
      });
    });
  }

  handleRangeChange(e) {
    let minValue, maxValue;
    const symbol = e.currentTarget.dataset.symbol;
    if(e.currentTarget.hasAttribute('data-min-value')) {
           maxValue = parseInt(this.maxRange.value);
           minValue = parseInt(e.currentTarget.value);
          if(minValue >= maxValue - 10) {
            e.currentTarget.value  = maxValue - 10;
            minValue = e.currentTarget.value;
          } 
          this.minPlaceholder.textContent = `${symbol} ${e.currentTarget.value}`;
        } else {
           minValue = parseInt(this.minRange.value);
           maxValue = parseInt(e.currentTarget.value);
          if(maxValue <= minValue + 10) {
            e.currentTarget.value = minValue + 10;
            maxValue = e.currentTarget.value;
          }
          this.maxPlaceholder.textContent = `${symbol} ${e.currentTarget.value}`;
        }
  }

  _handleTextInput(e) {
    const el = e.target;    
    const name = el.name;
    const value = (el.value || '').trim();

    const url = new URL(window.location.href);
    if (value) {
      url.searchParams.set(name, value);
    } else {
      url.searchParams.delete(name);
    }

    url.searchParams.set('sections', this.sectionId);

    document.dispatchEvent(new CustomEvent('collection-page-update', {
      detail: { url, sectionId: this.sectionId },
      bubbles: true
    }));

    this.updateURL(url);
  }

  _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  updateURL(url) {
    url.searchParams.delete('sections');
    window.history.pushState({}, '', url.toString());
  }
}

customElements.define('collection-filters', CollectionFilters);


// COLLECTION FILTER DRAWER
class CollectionFilterDrawer extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    this.inputs = this.querySelectorAll('input[type="checkbox"]');
    this.textInputs = this.querySelectorAll('input[type="text"]');
    this.activeFilters = this.querySelectorAll('.active_filter');
    this.range = this.querySelectorAll('input[type="range"]');
    this.minRange = this.querySelector('input[type="range"][data-min-value]');
    this.maxRange = this.querySelector('input[type="range"][data-max-value]');
    this.minPlaceholder = this.querySelector('.min_placeholder');
    this.maxPlaceholder = this.querySelector('.max_placeholder');
    this.selects = this.querySelectorAll('select');
    this.sectionId = this.dataset.sectionId;
    this.loader = this.closest('.filter_drawer_wrapper').querySelector('.loader_wrapper')

    //  this.range.forEach((range) => {     
    //   range.addEventListener('input', (e) => {
    //     this.loader.classList.add('active');
    //     this.handleRangeChange(e)
    //   });
    // })

    this.inputs.forEach((input) => {
      input.addEventListener('change', (e) => {
        this.loader.classList.add('active');
        const url = e.currentTarget.checked
          ? new URL(e.currentTarget.dataset.addUrl, window.location.origin)
          : new URL(e.currentTarget.dataset.removeUrl, window.location.origin);

        url.searchParams.set('sections', this.sectionId);
        document.dispatchEvent(new CustomEvent('collection-page-update', {
          detail: { url, sectionId: this.sectionId },
          bubbles: true
        }));
        this.updateURL(url);
      });

      
    });

    this.range.forEach((range) => {
      const debouncedHandler = this._debounce((e) => {
        this.loader.classList.add('active');
        const url = new URL(location.href);

        url.searchParams.delete(this.minRange.dataset.param);
        url.searchParams.delete(this.maxRange.dataset.param);
        url.searchParams.set(this.minRange.dataset.param, this.minRange.value);
        url.searchParams.set(this.maxRange.dataset.param, this.maxRange.value);

        url.searchParams.set('sections', this.sectionId);
        document.dispatchEvent(new CustomEvent('collection-page-update', {
          detail: { url, sectionId: this.sectionId },
          bubbles: true
        }));
        this.updateURL(url);
      }, 1000)

      range.addEventListener('input', (e) => {
        this.handleRangeChange(e)
        debouncedHandler(e)
      })
              
    });

    this.textInputs.forEach((textInput) => {
      const debouncedHandler = this._debounce((e) => this._handleTextInput(e), 1000);
      textInput.addEventListener('input', debouncedHandler);
    });

    this.activeFilters.forEach((activeFilter) => {
      activeFilter.addEventListener('click', (e) => {
        e.preventDefault();
        this.loader.classList.add('active');
        const url = new URL(e.currentTarget.href, window.location.origin);
        url.searchParams.set('sections', this.sectionId);
        document.dispatchEvent(new CustomEvent('collection-page-update', {
          detail: { url, sectionId: this.sectionId },
          bubbles: true
        }));
        this.updateURL(url);
      });
    });

    this.selects.forEach((select) => {
      select.addEventListener('change', (e) => {
        e.preventDefault();
        this.loader.classList.add('active');
        const value = select.value;
        const url = new URL(window.location.href, window.location.origin);
        url.searchParams.set('sort_by', value);
        url.searchParams.set('sections', this.sectionId);
        document.dispatchEvent(new CustomEvent('collection-page-update', {
          detail: { url, sectionId: this.sectionId },
          bubbles: true
        }));
        this.updateURL(url);
      });
    });
  }

  handleRangeChange(e) {
    let minValue, maxValue;
    const symbol = e.currentTarget.dataset.symbol;
    if(e.currentTarget.hasAttribute('data-min-value')) {
          maxValue = parseInt(this.maxRange.value);
          minValue = parseInt(e.currentTarget.value);
          if(minValue >= maxValue - 10) {
            e.currentTarget.value  = maxValue - 10;
            minValue = e.currentTarget.value;
          } 
          this.minPlaceholder.textContent = `${symbol} ${e.currentTarget.value}`;
        } else {
          minValue = parseInt(this.minRange.value);
          maxValue = parseInt(e.currentTarget.value);
          if(maxValue <= minValue + 10) {
            e.currentTarget.value = minValue + 10;
            maxValue = e.currentTarget.value;
          }
          this.maxPlaceholder.textContent = `${symbol} ${e.currentTarget.value}`;
        }
  }

  _handleTextInput(e) {
    const el = e.target;    
    const name = el.name;
    const value = (el.value || '').trim();

    const url = new URL(window.location.href);
    if (value) {
      url.searchParams.set(name, value);
    } else {
      url.searchParams.delete(name);
    }

    url.searchParams.set('sections', this.sectionId);

    document.dispatchEvent(new CustomEvent('collection-page-update', {
      detail: { url, sectionId: this.sectionId },
      bubbles: true
    }));

    this.updateURL(url);
   
  }

  _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  updateURL(url) {
    url.searchParams.delete('sections');
    window.history.pushState({}, '', url.toString());   
  }  
}

customElements.define('collection-filter-drawer', CollectionFilterDrawer);


// MOBILE FILTER DRAWER
class MobileFilterDrawer extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    this.inputs = this.querySelectorAll('input[type="checkbox"]');    
    this.textInputs = this.querySelectorAll('input[type="text"]');
    this.activeFilters = this.querySelectorAll('.active_filter');
    this.range = this.querySelectorAll('input[type="range"]');
    this.minRange = this.querySelector('input[type="range"][data-min-value]');
    this.maxRange = this.querySelector('input[type="range"][data-max-value]');
    this.minPlaceholder = this.querySelector('.min_placeholder');
    this.maxPlaceholder = this.querySelector('.max_placeholder');
    this.selects = this.querySelectorAll('select');
    this.sectionId = this.dataset.sectionId;
    this.loader = this.closest('.filter_drawer_wrapper').querySelector('.loader_wrapper');

    //  this.range.forEach((range) => {
    //   range.addEventListener('input', () => {
    //     this.loader.classList.add('active');
    //     this.handleRangeChange.bind(this)
    //   });
    // })

    this.inputs.forEach((input) => {      
      input.addEventListener('change', (e) => {
        this.loader.classList.add('active');
        const url = e.currentTarget.checked
          ? new URL(e.currentTarget.dataset.addUrl, window.location.origin)
          : new URL(e.currentTarget.dataset.removeUrl, window.location.origin);

        url.searchParams.set('sections', this.sectionId);
        document.dispatchEvent(new CustomEvent('collection-page-update', {
          detail: { url, sectionId: this.sectionId },
          bubbles: true
        }));
        this.updateURL(url);
      });

      const label = input.nextElementSibling;
      label.addEventListener('click', () => {
        this.loader.classList.add('active')
      })
    }); 

    this.range.forEach((range) => {
      const debouncedHandler = this._debounce((e) => {
        this.loader.classList.add('active');
        const url = new URL(location.href);

        url.searchParams.delete(this.minRange.dataset.param);
        url.searchParams.delete(this.maxRange.dataset.param);
        url.searchParams.set(this.minRange.dataset.param, this.minRange.value);
        url.searchParams.set(this.maxRange.dataset.param, this.maxRange.value);

        url.searchParams.set('sections', this.sectionId);
        document.dispatchEvent(new CustomEvent('collection-page-update', {
          detail: { url, sectionId: this.sectionId },
          bubbles: true
        }));
        this.updateURL(url);
      }, 1000)

      range.addEventListener('input', (e) => {
        this.handleRangeChange(e)
        debouncedHandler(e)
      })
              
    });

    this.textInputs.forEach((textInput) => {
      const debouncedHandler = this._debounce((e) => this._handleTextInput(e), 1000);
      textInput.addEventListener('input', debouncedHandler);
    });

    this.activeFilters.forEach((activeFilter) => {
      activeFilter.addEventListener('click', (e) => {
        e.preventDefault();
        this.loader.classList.add('active');
        const url = new URL(e.currentTarget.href, window.location.origin);
        url.searchParams.set('sections', this.sectionId);
        document.dispatchEvent(new CustomEvent('collection-page-update', {
          detail: { url, sectionId: this.sectionId },
          bubbles: true
        }));
        this.updateURL(url);
      });
    });

    this.selects.forEach((select) => {
      select.addEventListener('change', (e) => {
        this.loader.classList.add('active');
        e.preventDefault();
        const value = select.value;
        const url = new URL(window.location.href, window.location.origin);
        url.searchParams.set('sort_by', value);
        url.searchParams.set('sections', this.sectionId);
        document.dispatchEvent(new CustomEvent('collection-page-update', {
          detail: { url, sectionId: this.sectionId },
          bubbles: true
        }));
        this.updateURL(url);
      });
    });
  }

  handleRangeChange(e) {
    let minValue, maxValue
    const symbol = e.currentTarget.dataset.symbol;
    if(e.currentTarget.hasAttribute('data-min-value')) {
          maxValue = parseInt(this.maxRange.value);
          minValue = parseInt(e.currentTarget.value);
          if(minValue >= maxValue - 10) {
            e.currentTarget.value  = maxValue - 10;
            minValue = e.currentTarget.value;
          } 
          this.minPlaceholder.textContent = `${symbol} ${e.currentTarget.value}`;
        } else {
          minValue = parseInt(this.minRange.value);
          maxValue = parseInt(e.currentTarget.value);
          if(maxValue <= minValue + 10) {
            e.currentTarget.value = minValue + 10;
            maxValue = e.currentTarget.value;
          }
          this.maxPlaceholder.textContent = `${symbol} ${e.currentTarget.value}`;
        }
  }

  _handleTextInput(e) {
    const el = e.target;    
    const name = el.name;
    const value = (el.value || '').trim();

    const url = new URL(window.location.href);
    if (value) {
      url.searchParams.set(name, value);
    } else {
      url.searchParams.delete(name);
    }

    url.searchParams.set('sections', this.sectionId);

    document.dispatchEvent(new CustomEvent('collection-page-update', {
      detail: { url, sectionId: this.sectionId },
      bubbles: true
    }));

    this.updateURL(url);
   
  }

  _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  updateURL(url) {
    url.searchParams.delete('sections');
    window.history.pushState({}, '', url.toString());   
  }  
}

customElements.define('mobile-filter-drawer', MobileFilterDrawer);


// COLLECTION FILTER ICON
class CollectionFilterIcon extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('button');
    this.drawer = document.querySelector('.filter_drawer_wrapper');
  }

  connectedCallback() {
    this.addEventListener('click', () => {
        openDrawer(this.drawer, this.btn);

       
      document.querySelectorAll('.shopify-section').forEach((section) => {
        section.style.zIndex = '0';
        if(section.classList.contains('main-collection-section')) {
          section.style.zIndex = '5'
        }
      })
      document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '1';
      document.querySelector('.shopify-section-group-header-group.announcement-bar').style.zIndex = '1';      
    
    })    

    document.addEventListener('collection-page-update', (e) => {
      const url = e.detail.url;
      const sectionId = e.detail.sectionId;
    })
  }
}

customElements.define('collection-filter-icon', CollectionFilterIcon);


// MAIN COLLECTION
class MainCollection extends HTMLElement {
  constructor() {
    super();    
    this.filterWrapper = document.querySelector('.filter_drawer_wrapper');
    this.cursor = document.querySelector('.cursor_pointer');
    this.next = this.querySelector('.infinite-scroll--next');

    this.grid = document.querySelector('.main_collection_product_grid');
    if (!this.grid) return;

    this.items = this.grid.querySelectorAll('.main_collection_product');
    if (!this.items.length) return;

    this.updateHeights = this.updateHeights.bind(this);

    window.addEventListener('load', this.updateHeights);
    window.addEventListener('resize', this.debounce(this.updateHeights, 150));
  }

  connectedCallback() {
    document.addEventListener('collection-page-update', (e) => {
      const sectionId = e.detail.sectionId;
      const url = e.detail.url;
      this.handleUpdate(url, sectionId);
      if(this.filterWrapper) {
        this.handleFilterDrawerUpdate(url, sectionId);
      }
    })

    if(this.next) {
      this.next.addEventListener('click', () => this.loadProducts(this.next));
    }
  }

  updateHeights() {
    const firstItem = this.items[0];
    if (!firstItem) return;

    const height = firstItem.getBoundingClientRect().height;

    this.items.forEach(item => {
      item.style.setProperty('--height', `${height}px`);
    });
  }

  debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  loadProducts(nextBtn) {
    const url = nextBtn.dataset.nextUrl;

    nextBtn.querySelector('.lm').classList.add('hidden');
    nextBtn.querySelector('.pl').classList.remove('hidden');
    if(!url) return; 

    fetch(url)
    .then((res) => res.text())
    .then((htmlString) => {
      const html = new DOMParser().parseFromString(htmlString, 'text/html');

      const oldWrapper = document.querySelector('.main_collection_product_grid');
      const newWrapper = html.querySelector('.main_collection_product_grid');

      if(oldWrapper && newWrapper) {
        [...newWrapper.children].forEach((item) => {
            // Import node into current document to avoid issues
            oldWrapper.appendChild(document.importNode(item, true));
          });
      }

      const oldBtn = document.querySelector('.infinite-scroll--next');
      const newBtn = html.querySelector('.infinite-scroll--next');

      if(newBtn) {
        oldBtn.dataset.nextUrl = newBtn.dataset.nextUrl
      } else {
        oldBtn.remove();
      }

      nextBtn.querySelector('.lm').classList.remove('hidden');
      nextBtn.querySelector('.pl').classList.add('hidden');
    })
  }

  handleUpdate(url, sectionId) {
    fetch(url.toString())
    .then((res) => res.json())
    .then((data) => {
      const temp = document.createElement('div');
      temp.innerHTML = data[sectionId];
      if(temp) {
        document.querySelector('main-collection').innerHTML = temp.querySelector('main-collection').innerHTML;

        const next = this.querySelector('.infinite-scroll--next');
        if(next) {
          next.addEventListener('click', () => this.loadProducts(next));
        }
      }     
    })
  }

  handleFilterDrawerUpdate(url, sectionId) {
    fetch(url.toString())
    .then((res) => res.json())
    .then((data) => {
      const temp = document.createElement('div');
      temp.innerHTML = data[sectionId];
      if(temp) {
        document.querySelector('.filter_drawer_wrapper').innerHTML = temp.querySelector('.filter_drawer_wrapper').innerHTML;
        document.querySelector('.filter_drawer_wrapper').querySelector('.filter_drawer_inner').addEventListener('mouseenter', () => {
          this.cursor.classList.remove('close');
        })

        if(this.next) {
          this.next.addEventListener('click', this.loadProducts.bind(this));
        }

        document.querySelector('.filter_drawer_wrapper').querySelector('.filter_drawer_inner').addEventListener('mouseleave', () => {
          this.cursor.classList.add('close');
        })

        const drawer = document.querySelector('.filter_drawer_wrapper');
        const drawerClose = drawer.querySelector('.main_drawer_close');
        drawerClose.addEventListener('click', () => {
          closeDrawer(drawer);
        })
      }     
    })
  }
}

customElements.define('main-collection', MainCollection);


// MAIN SEARCH
class MainSearch extends HTMLElement {
  constructor() {
    super();    
    this.filterWrapper = document.querySelector('.filter_drawer_wrapper');
    this.cursor = document.querySelector('.cursor_pointer')
  }

  connectedCallback() {
    document.addEventListener('collection-page-update', (e) => {
      const sectionId = e.detail.sectionId;
      const url = e.detail.url;
      this.handleUpdate(url, sectionId);
      if(this.filterWrapper) {
        this.handleFilterDrawerUpdate(url, sectionId);
      }
    })
  }

  handleUpdate(url, sectionId) {
    fetch(url.toString())
    .then((res) => res.json())
    .then((data) => {
      const temp = document.createElement('div');
      temp.innerHTML = data[sectionId];
      if(temp) {
        document.querySelector('main-search').innerHTML = temp.querySelector('main-search').innerHTML;
      }     
    })
  }

  handleFilterDrawerUpdate(url, sectionId) {
    fetch(url.toString())
    .then((res) => res.json())
    .then((data) => {
      const temp = document.createElement('div');
      temp.innerHTML = data[sectionId];
      if(temp) {
        document.querySelector('.filter_drawer_wrapper').innerHTML = temp.querySelector('.filter_drawer_wrapper').innerHTML;
        document.querySelector('.filter_drawer_wrapper').querySelector('.filter_drawer_inner').addEventListener('mouseenter', () => {
          this.cursor.classList.remove('close');
        })

        document.querySelector('.filter_drawer_wrapper').querySelector('.filter_drawer_inner').addEventListener('mouseleave', () => {
          this.cursor.classList.add('close');
        })

        const drawer = document.querySelector('.filter_drawer_wrapper');
        const drawerClose = drawer.querySelector('.main_drawer_close');
        drawerClose.addEventListener('click', () => {
          closeDrawer(drawer);
        })
      }     
    })
  }
}

customElements.define('main-search', MainSearch);


// MAIN LOGIN
class MainLogin extends HTMLElement {
  constructor() {
    super();
    this.loginWrapper = this.querySelector('.main_login_wrapper');
    this.recoverWrapper = this.querySelector('.main_recover_wrapper');
    this.forgotPassword = this.querySelector('#forgot_password');
    this.return = this.querySelector('#link_login');
    this.loadContent();
  }

  connectedCallback() {
    this.forgotPassword.addEventListener('click', this.handleForgotPasswordClick.bind(this));
    this.return.addEventListener('click', this.handleReturnClick.bind(this));
  }

  loadContent() {
    const url = window.location.href;
    if(url.includes('#recover')) {
      this.loginWrapper.classList.add('recover');
      this.recoverWrapper.classList.remove('recover');
    }
  }

  handleForgotPasswordClick(e) {
    e.preventDefault();
    this.loginWrapper.classList.add('recover');
    this.recoverWrapper.classList.remove('recover');
    const url = `${window.location.href}#recover`;
    window.history.pushState({}, "", url);
  }

  handleReturnClick(e) {
    e.preventDefault();
    this.loginWrapper.classList.remove('recover');
    this.recoverWrapper.classList.add('recover');
    let url = window.location.href;
    url = url.split('#recover');
    const newURL = url[0];
    window.history.pushState({}, "", newURL)
  }
}

customElements.define('main-login', MainLogin);


if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};


// NEW ADDRESS FORM
class NewAddress extends HTMLElement {
  constructor() {
    super();
    this.newAddressBtn = document.querySelector('.new_address_btn');
    this.formWrapper = this.querySelector('.new_address_form');
    this.formInner = this.formWrapper.querySelector('.new_address_form_inner');
    this.close = this.querySelector('.new_address_form_close');
    this.reset = this.querySelector('.reset_btn');
  }

  connectedCallback() {
    const height = this.formInner.clientHeight + 100;
    this.formWrapper.style.setProperty('--height', `${height}px`);
    if(this.newAddressBtn) {
      this.newAddressBtn.addEventListener('click', this.handleClick.bind(this));
    }

    if(this.close) {
      this.close.addEventListener('click', this.handleClose.bind(this));
    }

    if(this.reset) {
      this.reset.addEventListener('click', this.handleClose.bind(this));
    }
  }

  handleClick() {
    if(this.formWrapper.hasAttribute('open')) {} 
    else {
      this.formWrapper.setAttribute('open', '');
    }
  }

  handleClose() {
    if(this.formWrapper.hasAttribute('open')) {
      this.formWrapper.removeAttribute('open')
    }     
  }
}

customElements.define('new-address', NewAddress);


// EDIT ADDRESS FORM
class EditAddress extends HTMLElement {
  constructor() {
    super();
    this.edit = this.querySelector('.edit_btn');
    this.wrapper = this.querySelector('.edit_address_wrapper');
    this.inner = this.wrapper.querySelector('.edit_address_inner');
    this.resetBtn = this.querySelector('.reset_btn');
  }

  connectedCallback() {
    this.edit.addEventListener('click', this.handleClick.bind(this));
    const height = this.inner.clientHeight + 150;
    this.wrapper.style.setProperty('--height', `${height}px`);
    this.resetBtn.addEventListener('click', this.handleClose.bind(this));
  }

  handleClick(e) {
    e.preventDefault();
    if(this.wrapper.hasAttribute('open')){} {
      this.wrapper.setAttribute('open', '')
    }
  }

  handleClose(e) {
    e.preventDefault();
    if(this.wrapper.hasAttribute('open')) {
      this.wrapper.removeAttribute('open');
    }
  }
}

customElements.define('edit-address', EditAddress);


// SEARCH RESET BUTTON
class searchReset extends HTMLElement {
  constructor() {
    super();
  } 

  connectedCallback() {
    this.form = this.closest('form[role="search"]');
    this.btn = this.querySelector('button.button_reset');
    this.btn.addEventListener('click', this.handleReset.bind(this));
  }

  handleReset(e) {
    e.preventDefault();
    const url = new URL(window.location.href);
    url.search = '';
    window.location.href = url.toString();
  }
}

customElements.define('search-reset', searchReset);


// COLLAPSIBLE TAB
class CollapsibleTab extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.closest('product-info').querySelectorAll('collapsible-tab');
    this.tabTitle = this.querySelector('.collapsible_tab_title');
    this.content = this.querySelector('.collapsible_tab_content');
    this.innerContent = this.querySelector('.collapsible_tab_content_inner');
    this.icon = this.querySelector('.vert');

    this.updateHeight = this.updateHeight.bind(this);
  }

  connectedCallback() {
    this.updateHeight();
    this.tabTitle.addEventListener('click', this.handleClick.bind(this));
    window.addEventListener('resize', this.updateHeight);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updateHeight);
  }

  updateHeight() {
    const height = this.innerContent.clientHeight;
    this.content.style.setProperty('--height', `${height}px`);
  }

  handleClick() {
    this.tabs.forEach((tab) => {
      if (tab !== this) {
        tab.content.classList.remove('full_height');
        tab.icon.classList.remove('rotate');
      }
    })
    this.content.classList.toggle('full_height');
    this.icon.classList.toggle('rotate');
  }
}

customElements.define('collapsible-tab', CollapsibleTab);



// RECOMMENDED PRODUCTS
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.recommendedURL = this.dataset.url;
    this.spacing = this.dataset.spacing;
    this.columns = this.dataset.columns;
    this.mobColumns = this.dataset.mobColumns;

    this.observer = new IntersectionObserver(this.handleObserver, {
      rootMargin: "0px 0px 500px 0px",
    }); 
  }

  connectedCallback() {
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  handleObserver = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.observer.disconnect(); 
        requestAnimationFrame(() => {
          this.loadRecommendedProducts(
            this.recommendedURL,
            this.productId,
            this.sectionId
          );
        });
      }
    });
  };

  loadRecommendedProducts(recommendedURL, productId, sectionId) {
    fetch(`${recommendedURL}&product_id=${productId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((data) => {
        const html = document.createElement("div");
        html.innerHTML = data;
        const recommendedProducts = html.querySelector("product-recommendations");

        if (recommendedProducts?.innerHTML.trim().length) {
          this.innerHTML = recommendedProducts.innerHTML;

          this.productsInner =
            this.querySelector(".product_recommendations_inner") ||
            this.querySelector(".complementary_products_inner");

          this.initRecommendedSlider(
            this.productsInner,
            this.spacing,
            this.columns,
            this.mobColumns
          );

          document.dispatchEvent(new CustomEvent("RecommendedProductsUpdated"));                
        }
      });
  }

  initRecommendedSlider(inner, spacing, columns, mobColumns) {
    const prevBtn = this.querySelector('.pr_prev');
    const nextBtn = this.querySelector('.pr_next');

    new Swiper(inner, {
      slidesPerView: columns,
      spaceBetween: spacing,    
      navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },  
      breakpoints: {
        0: {
          slidesPerView: mobColumns,
          spaceBetween: spacing,
        },
        640: {
          slidesPerView: columns,
          spaceBetween: spacing,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: spacing,
        },        
        1280: {
          slidesPerView: 4,
          spaceBetween: spacing,
        },
        1399: {
          slidesPerView: columns,
          spaceBetween: spacing,
        },
      },
    });
  }
}

customElements.define("product-recommendations", ProductRecommendations);


// COMPLETE YOUR LOOK
class CompleteYourLook extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.cyl_slider');
    this.spacing = this.dataset.spacing;
    this.prevBtn = this.querySelector('.swiper-button-prev').getAttribute('class');
    this.nextBtn = this.querySelector('.swiper-button-next').getAttribute('class');
  }

  connectedCallback() {
    new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: this.spacing,    
      navigation: {
          nextEl: `.${this.nextBtn}`,
          prevEl: `.${this.prevBtn}`,
        }        
    });
  }
}

customElements.define('complete-your-look', CompleteYourLook);


// SEARCH DRAWER
(function () {
  const words = ["a product...", "an article...", "a page...", "a collection..."];
  const typeSpeed = 120;
  const deleteSpeed = 60;
  const pauseAfter = 900;
  const pauseBetween = 300;

  const input = document.getElementById('main_header_search_input');
  if(!input) return;
  const label = input.nextElementSibling;
  const liveRegion = document.getElementById('search-typer');
  if (!input || !label) return;

  const fixedPrefix = 'Search for ';
  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  let typing = true;
  let timeoutId = null;

  input.addEventListener('focus', () => {
    typing = false;
    if (timeoutId) clearTimeout(timeoutId);
    input.placeholder = fixedPrefix;
    label.textContent = fixedPrefix;
    document.querySelector('.main_header_search_input_wrapper')?.classList.remove('typing');
  });

  input.addEventListener('blur', () => {
    if (!typing) {
      typing = true;
      timeoutId = setTimeout(typeLoop, 300);
    }
  });

  function setText(text) {
    input.placeholder = fixedPrefix + text;
    label.textContent = fixedPrefix + text;
    if (liveRegion) liveRegion.textContent = text;
  }

  function typeLoop() {
    if (!typing) return;

    const currentWord = words[wordIndex];
    if (!isDeleting) {
      charIndex++;
      const partial = currentWord.substring(0, charIndex);
      setText(partial);
      document.querySelector('.main_header_search_input_wrapper')?.classList.add('typing');

      if (charIndex === currentWord.length) {
        isDeleting = true;
        timeoutId = setTimeout(typeLoop, pauseAfter);
      } else {
        timeoutId = setTimeout(typeLoop, typeSpeed);
      }
    } else {
      charIndex--;
      const partial = currentWord.substring(0, charIndex);
      setText(partial);

      if (charIndex === 0) {
        isDeleting = false;
        wordIndex = (wordIndex + 1) % words.length;
        timeoutId = setTimeout(typeLoop, pauseBetween);
      } else {
        timeoutId = setTimeout(typeLoop, deleteSpeed);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (document.activeElement !== input) {
        typing = true;
        typeLoop();
      }
    });
  } else {
    if (document.activeElement !== input) {
      typing = true;
      typeLoop();
    }
  }
})();

class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.sc_slider');
    this.spacing = this.dataset.spacing;  
    this.input = this.querySelector('input#main_header_search_input');
    this.reset = this.querySelector('.reset_search');
    this.emptySearchWrapper = this.querySelector('.header_search_empty_wrapper');
    this.resultsWrapper = this.querySelector('.header_search_results_wrapper');
    this.resultsInner = this.resultsWrapper.querySelector('.header_search_results_inner');
    this.resultsHeader = this.resultsWrapper.querySelector('.header_search_results_header');
  }

  connectedCallback() {
    const prevBtn = this.querySelector('.swiper-button-prev.header_search_prev');
    const nextBtn = this.querySelector('.swiper-button-next.header_search_next');

    new Swiper(this.slider, {
      slidesPerView: 2.5,
      speed: 600,
      spaceBetween: this.spacing,    
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      a11y: {
        enabled: false 
      }     
    });

    if(this.input) {
      this.input.addEventListener('input', this.debounce(() => this.handleInput(), 300))
    } else {
      console.error("Search input not found.");
    }

    this.input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault(); // stop empty instant submit

        const query = this.input.value.trim();
        if (query.length > 0) {
          window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(query)}&options[prefix]=last`;
        }
      }
    });

    this.reset.addEventListener('click', () => {
      this.input.value = "";
      this.clearResults();
      this.emptySearchWrapper.style.display = "flex";
      this.resultsWrapper.style.display = "none";
    });
  }

  debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  handleInput() {
    const query = this.input.value.trim();
    if(query.length === 0){
      this.clearResults();
      this.emptySearchWrapper.style.display = "flex";
      this.resultsWrapper.style.display = "none";
      return;
    }

    fetch(window.Shopify.routes.root + `search/suggest.json?q=${query}&resources[type]=product,collection,article,page`)
    .then((res) => res.json())
    .then(({ resources }) => {
      this.showResults(resources.results)
    })
    .catch((error) => console.error('Error fetching results: ', error))
  }

  showResults(results) {
    this.emptySearchWrapper.style.display = "none";
    this.resultsWrapper.style.display = "block"; 
   
    const productLength = results.products.length;
    const collectionLength = results.collections.length;
    const articleLength = results.articles.length;
    const pageLength = results.pages.length;

    this.resultsHeader.innerHTML = "";
    this.resultsInner.innerHTML = ""

    if(productLength > 0) {
      this.renderProducts(results, collectionLength, productLength, articleLength, pageLength);
    }    

    if(collectionLength > 0) {
      this.renderCollections(results, collectionLength, productLength, articleLength, pageLength);
    }
    
    if(articleLength > 0) {
      this.renderArticles(results, collectionLength, productLength, articleLength, pageLength);
    }    

    if(pageLength > 0) {
      this.renderPages(results, collectionLength, productLength, articleLength, pageLength)
    }

    if(productLength == 0 && collectionLength == 0 && articleLength == 0 && pageLength == 0) {
      const emptyHeader = document.createElement("h2");
      emptyHeader.classList.add('h4', 'empty_results_header')
      emptyHeader.textContent = "No results found.";
      this.resultsInner.appendChild(emptyHeader)
    }

    const headings = this.resultsHeader.querySelectorAll('h2.h6');
    const search_blocks = this.resultsInner.querySelectorAll('.search_result_block');

    headings.forEach((heading) => {
      heading.addEventListener('click', () => {
        headings.forEach((h) => {
          h.classList.remove('active');
          heading.classList.add('active');
        })
        const header = heading.dataset.header;
        this.handleClick(header, search_blocks);
      })
    })
  }

  renderProducts(results, collectionLength, productLength, articleLength, pageLength) {
      const productHeader = document.createElement("h2");
      productHeader.classList.add('h6', 'active');
      productHeader.setAttribute('data-header', 'products');
      productHeader.innerHTML = `<button aria-label="Products">Products (${productLength})</button>`;

      this.resultsHeader.appendChild(productHeader);

      const productWrapper = document.createElement("div");
      productWrapper.setAttribute('data-header', 'products');
      productWrapper.classList.add("product-wrapper", "search_result_block");

      let products = results.products;
      products.forEach((product, i) => {
        let money_format = document
          .querySelector(".header_main_wrapper")
          .dataset.moneyFormat;
        let price = Shopify.formatMoney(product.price_min, money_format);
        let cap_price = Shopify.formatMoney(
          product.compare_at_price_min,
          money_format
        );
        let pro = `<div class="header_search_product-card">
            <div class="header_search_product_card_img ratio" style="--aspect-ratio: 100%;">              
                <a aria-label="${product.title}" tabindex="0" href="${product.url}"><img src="${product.featured_image.url}" alt="${product.title}"/></a>
            </div>
            <div class="header_search_product_card_info">
            <h3 class="small-text"><a aria-label="${product.title}" href="${product.url}">${product.title}</a></h3> 
            <div class="header_search_product_card_price_wrapper">
              <p data-cap="${product.compare_at_price_min}" class="cap_price"><s>${cap_price}</s></p>
              <p class="og_price">${price}</p>            
            </div>
            </div>
          </div>`;

        productWrapper.innerHTML += pro;
      }); 
      
      this.resultsInner.appendChild(productWrapper);

  }

  renderCollections(results, collectionLength, productLength, articleLength, pageLength) {
      const collectionHeader = document.createElement("h2");
      collectionHeader.classList.add('h6');
      collectionHeader.setAttribute('data-header', 'collections');
      collectionHeader.innerHTML = `<button aria-label="Collections">Collections (${collectionLength})</button>`;

      if (productLength === 0 && articleLength === 0 && pageLength === 0) {
        collectionHeader.classList.add("active");
      } 

      this.resultsHeader.appendChild(collectionHeader);

      const collectionWrapper = document.createElement("div");
      collectionWrapper.setAttribute('data-header', 'collections');
      if (productLength === 0 && articleLength === 0 && pageLength === 0) {
        collectionWrapper.classList.add("collection-wrapper", "search_result_block");
      } else {
        collectionWrapper.classList.add("nodisp", "collection-wrapper", "search_result_block");
      }

      let collections = results.collections;
      collections.forEach((collection, i) => {
        let coll = `<div class="header_search_collection-card">            
            <h3 class="small-text"><a aria-label="${collection.title}" href="${collection.url}">${collection.title}</a></h3>            
          </div>`;

        collectionWrapper.innerHTML += coll;
      });

      this.resultsInner.appendChild(collectionWrapper);    
  }

  renderArticles(results, productLength, collectionLength, articleLength, pageLength) {
      const articleHeader = document.createElement("h2");
      articleHeader.classList.add('h6');
      articleHeader.setAttribute('data-header', 'articles');
      articleHeader.innerHTML = `<button aria-label="Articles">Articles (${articleLength})</button>`;

      if (productLength === 0 && collectionLength === 0 && pageLength === 0) {
        articleHeader.classList.add("active");
      }

      this.resultsHeader.appendChild(articleHeader);

      const articleWrapper = document.createElement("div");
      articleWrapper.setAttribute('data-header', 'articles');
      if (productLength === 0 && collectionLength === 0 && pageLength === 0) {
        articleWrapper.classList.add("article-wrapper", "search_result_block");
      } else {
        articleWrapper.classList.add("nodisp", "article-wrapper", "search_result_block");
      }

      let articles = results.articles;
      articles.forEach((article, i) => {
        let art = `
          <div class="header_search_article-card">
            <div class="header_search_article_card_img ratio" style="--aspect-ratio: 100%;">              
                <a aria-label="${article.url}" href="${article.url}"><img src="${article.featured_image.url}" alt="${article.title}"/></a>
            </div>
            <div class="header_search_article_card_info">
            <h3 class="small-text"><a aria-label="${article.url}" href="${article.url}">${article.title}</a></h3>            
            <p class="header_search_article_author">Author: ${article.author}</p>
            </div>
          </div>`;

        articleWrapper.innerHTML += art;
      });

      this.resultsInner.appendChild(articleWrapper);    
  }

  renderPages(results, collectionLength, productLength, articleLength, pageLength) {
      const pageHeader = document.createElement("h2");
      pageHeader.classList.add('h6');
      pageHeader.setAttribute('data-header', 'pages');
      pageHeader.innerHTML = `<button aria-label="Pages">Pages (${pageLength})</button>`;

      if (productLength === 0 && articleLength === 0 && collectionLength === 0) {
        pageHeader.classList.add("active");
      } 

      this.resultsHeader.appendChild(pageHeader);      

      const pageWrapper = document.createElement("div");
      pageWrapper.setAttribute('data-header', 'pages');
      if (productLength === 0 && articleLength === 0 && collectionLength === 0) {
        pageWrapper.classList.add("page-wrapper", "search_result_block");
      } else {
        pageWrapper.classList.add("nodisp", "page-wrapper", "search_result_block");
      }

      let pages = results.pages;
      pages.forEach((page, i) => {
        let coll = `<div class="header_search_page-card">            
            <h3 class="small-text"><a aria-label="${page.title}" href="${page.url}">${page.title}</a></h3>            
          </div>`;

        pageWrapper.innerHTML += coll;
      });

      this.resultsInner.appendChild(pageWrapper);    
  }

  clearResults() {
    this.resultsInner.innerHTML = "";        
    this.resultsHeader.innerHTML = "";        
  }

  handleClick(header, blocks) {
    blocks.forEach((block) => {
      const h = block.dataset.header;
      if(header == h) {
        block.classList.remove('nodisp');
      } else {
        block.classList.add('nodisp');
      }
    })
  }
}

customElements.define('header-search', HeaderSearch);


// QUICK ADD
class QuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.productUrl = this.dataset.productUrl;
    this.mainDrawer = document.querySelector('.quick_add_drawer_wrapper');
    this.drawer = document.querySelector('.quick_add_drawer_inner');
    this.btn = this.closest('button.qa_btn');
  }

  connectedCallback() {   
   this.attachEvents(); 
  }

  attachEvents() {
    if (this._eventsAttached) return;
    this._eventsAttached = true;
    this.btn.addEventListener('click', (e) => {      
      this.handleFetch();

      if(this.drawer.classList.contains('mobile_drawer_wrapper')) {
      document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '2';
      document.querySelector('.shopify-section-group-header-group.announcement-bar').style.zIndex = '2';
    } else {
      document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '1';
      document.querySelector('.shopify-section-group-header-group.announcement-bar').style.zIndex = '1';
      document.querySelectorAll('.shopify-section').forEach((section) => {
        section.style.zIndex = '0';
      })
    }

    if(this.drawer.classList.contains('pickup_availability_drawer')) {
      this.drawer.closest('.shopify-section').style.zIndex = '1'
    }

      openDrawer(this.mainDrawer, this.btn)
    });
  }

  handleFetch() {
    fetch(this.productUrl)
    .then((res) => res.text())
    .then((data) => {
      const temp = document.createElement('div');
      temp.innerHTML = data
      const updatedHTML = temp.querySelector('.main_product_inner');

      const originalSectionId = updatedHTML.querySelector('product-info').dataset.sectionId;
      const updatedSectionId = `quick-add-${originalSectionId}`;

      updatedHTML.innerHTML = updatedHTML.innerHTML.replaceAll(originalSectionId, updatedSectionId);
      updatedHTML.querySelector('product-info').dataset.originalSectionId = originalSectionId;

      updatedHTML.querySelector('product-info').dataset.updateUrl = 'false';     
      const ctabs = updatedHTML.querySelectorAll('collapsible-tab');
      const scart = updatedHTML.querySelector('sticky-cart');
      const sChart = updatedHTML.querySelector('.size_chart_wrapper');

      if(ctabs) {
        ctabs.forEach((tab) => {
          tab.remove();
        })
      }

      if(scart) {
        scart.remove();        
      }

      if(sChart) {
        sChart.remove();
      }

      if(this.drawer) {
        this.drawer.innerHTML = updatedHTML.innerHTML;
      }
    })
  }
}

customElements.define('quick-add-button', QuickAddButton);

document.addEventListener('collection-page-update', () => {
  document.querySelectorAll('quick-add-button').forEach((el) => {
    el.attachEvents();
  });
});


// MAIN PASSWORD HEADER
class MainPasswordHeader extends HTMLElement {
  constructor() {
    super();
    this.open = this.querySelector('.modal__toggle-open');
    this.close = this.querySelector('.main_password_popup_close');
    this.input = this.querySelector('input[name="password"]');     
    this.errors = this.querySelector('#main_password_page_form_errors_wrapper');
    
  }

  connectedCallback() {
    if(this.input.hasAttribute('aria-invalid')) {
      this.setAttribute('open', '')
    }
    this.open.addEventListener('click', this.handleClick.bind(this));
    this.close.addEventListener('click', this.handleClose.bind(this));
  }

  handleClick() {
    if(this.hasAttribute('open')) {
      this.removeAttribute('open');
    } else {
      this.setAttribute('open', '');
    }
  }

  handleClose() {
    this.input.removeAttribute('aria-invalid');
    if(this.errors) {
      this.errors.style.display = 'none'
    }
    this.removeAttribute('open');
  }
}

customElements.define('main-password-header', MainPasswordHeader);


// MOBILE DRAWER
function slideDown(el) {
  el.style.maxHeight = el.scrollHeight + "px";

  requestAnimationFrame(() => {
    const parentAccordion = el.closest(".main-accordion-content");
    if (parentAccordion) {
      parentAccordion.style.maxHeight =
        parentAccordion.scrollHeight + el.scrollHeight + "px";
    }
  });
}

function slideUp(el) {
  el.style.maxHeight = "0";

  requestAnimationFrame(() => {
    const parentAccordion = el.closest(".accordion-content");
    if (parentAccordion && parentAccordion !== el) {
      parentAccordion.style.maxHeight = parentAccordion.scrollHeight + "px";
    }
  });
}

function closeSiblings(currentToggle) {
  const parentWrapper =
    currentToggle.closest(".accordion-wrapper") ||
    currentToggle.parentElement.parentElement;
  const allToggles = parentWrapper.querySelectorAll(".accordion-toggle");

  allToggles.forEach((toggle) => {
    if (toggle === currentToggle) return;

    const content = toggle.nextElementSibling;
    if (content?.classList.contains("accordion-content")) {
      toggle.classList.remove("active");
      toggle.querySelector?.(".plus_vertical")?.classList.remove("rot");
      slideUp(content);
    }
  });
}

document.querySelectorAll(".accordion-toggle button").forEach((toggle) => {
  toggle.addEventListener("click", () => {
    const content = toggle.closest(".accordion-toggle").nextElementSibling;
    const isOpen = toggle
      .closest(".accordion-toggle")
      .classList.contains("active");
    const plus = toggle
      .closest(".accordion-toggle")
      .querySelector?.(".plus_vertical");

    closeSiblings(toggle.closest(".accordion-toggle"));

    if (content?.classList.contains("accordion-content")) {
      toggle.closest(".accordion-toggle").classList.toggle("active", !isOpen);
      plus?.classList.toggle("rot", !isOpen);

      if (isOpen) {
        slideUp(content);
      } else {
        slideDown(content);
      }
    }
  });

  toggle.addEventListener("focusin", (e) => {
    const el = e.target;
    if(el.matches(':focus-visible')) {
      const content = toggle.closest(".accordion-toggle").nextElementSibling;
      const isOpen = toggle
        .closest(".accordion-toggle")
        .classList.contains("active");
      const plus = toggle
        .closest(".accordion-toggle")
        .querySelector?.(".plus_vertical");

      closeSiblings(toggle.closest(".accordion-toggle"));

      if (content?.classList.contains("accordion-content")) {
        toggle.closest(".accordion-toggle").classList.toggle("active", !isOpen);
        plus?.classList.toggle("rot", !isOpen);

        if (isOpen) {
          slideUp(content);
        } else {
          slideDown(content);
        }
      }
    }
  });
});



// TEASER
document.addEventListener('DOMContentLoaded', () =>{
  const teaser = document.querySelector('.teaser');
  if(!teaser)return;

  const position = teaser.dataset.position;

  if(teaser) {
    const els = teaser.querySelectorAll('button, a');
    els.forEach((el) => {
      el.addEventListener('focus', (e) => {
        if(e.target.matches(':focus-visible')) {
          teaser.style.transform = 'translate(0)';
        }
      })

      el.addEventListener('blur', (e) => {
        if(position == 'left') {
          teaser.style.transform = 'translate(calc(-100% + 1rem))';
        } else {
          teaser.style.transform = 'translate(calc(100% - 1rem))';
        }          
      })
    })
  }
})



// BACK TO TOP
class BackToTop extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 200) {
        this.classList.add("visible");
      } else {
        this.classList.remove("visible");
      }
    })

    this.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }
}

customElements.define('back-to-top', BackToTop);


// SIZE CHART

document.addEventListener('click', (e) => {
  const sizeChartTrigger = e.target.closest('.size_chart_wrapper');
  const sizeChartPopup = document.querySelector('.size_chart_popup_wrapper');
  const cursor = document.querySelector('.cursor_pointer');
  const sections = document.querySelectorAll('.shopify-section');
  

  if(sizeChartTrigger && sizeChartPopup) {
    sizeChartPopup.classList.add('active');
    sections.forEach((section) => {
      section.style.zIndex = 'unset';
    })
    document.body.setAttribute("data-scroll-locked", true);
    lenis.stop();     
  }

  if(sizeChartPopup) {
    sizeChartPopup.addEventListener('click', () => {
      sizeChartPopup.classList.remove('active');
      sections.forEach((section) => {
        section.style.zIndex = '0';
      })
      document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '4';
      document.querySelector('.shopify-section-group-header-group.announcement-bar').style.zIndex = '4';
      document.body.removeAttribute("data-scroll-locked");
        lenis.start();
    })

    const sizeChartInner = sizeChartPopup.querySelector('.size_chart_popup_inner');
    if(sizeChartInner) {
      sizeChartInner.addEventListener('click', (e) => {
        e.stopPropagation();
      })
    }

    const sizeChartClose = sizeChartPopup.querySelector('.size_chart_popup_close');
    if(sizeChartClose) {
      sizeChartClose.addEventListener('click', () => {
        sizeChartPopup.classList.remove('active');
        sections.forEach((section) => {
          section.style.zIndex = '0';
        })
        document.querySelector('.shopify-section-group-header-group.header-section').style.zIndex = '4';
        document.querySelector('.shopify-section-group-header-group.announcement-bar').style.zIndex = '4';  
        document.body.removeAttribute("data-scroll-locked");
        lenis.start();
      })      
    }

    sizeChartPopup.addEventListener('mouseenter', () => {
      cursor.classList.add('close');
    })

    sizeChartPopup.addEventListener('mouseleave', () => {
      cursor.classList.remove('close');
    })

    sizeChartInner.addEventListener('mouseenter', () => {
      cursor.classList.remove('close');
    })

    sizeChartInner.addEventListener('mouseleave', () => {
      cursor.classList.add('close');
    })
  }
})


// PRODUCT MEDIA
class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll('video');
    this.youtubeIframes = this.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
    this.vimeoIframes = this.querySelectorAll('iframe[src*="vimeo.com"]');
    this.models = this.querySelectorAll('product-model');
  }

  connectedCallback() {
    // HTML5 <video>
    this.videos.forEach((video) => {
      video.previousElementSibling.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleVideoClick(video)
      });
    });

    // YouTube <iframe>
    this.youtubeIframes.forEach((iframe) => {
      iframe.nextElementSibling.addEventListener('click', (e) => {
        iframe.nextElementSibling.style.pointerEvents = 'none';
        e.preventDefault();
        this.handleYoutubeClick(iframe)
      });
    });

    // Vimeo <iframe>
    this.vimeoIframes.forEach((iframe) => {
      iframe.nextElementSibling.addEventListener('click', (e) => {
        iframe.nextElementSibling.style.pointerEvents = 'none';
        e.preventDefault();
        this.handleVimeoClick(iframe)
      })
    });

    // Product model
    this.models.forEach((model) => {      
      model.addEventListener('mouseenter', () => {   
        lenis.stop();     
        document.documentElement.style.overflow = 'auto';
      })

      model.addEventListener('mouseleave', () => {        
        lenis.start();
        document.documentElement.style.overflow = 'unset';
      })

      model.addEventListener('click', (e) => this.handleModelClick(model));      
    });
  }

  // Handle native video
  handleVideoClick(currentVideo) {
    this.pauseAll(currentVideo);
    currentVideo.previousElementSibling.classList.add('fade');

    if(currentVideo.paused) {
      currentVideo.play();
      currentVideo.previousElementSibling.classList.add('fade');
    } else {
      currentVideo.previousElementSibling.classList.remove('fade');
      currentVideo.pause();
    }
  }

  // Handle YouTube iframe
  handleYoutubeClick(currentIframe) {
    this.pauseAll(currentIframe);
    currentIframe.contentWindow.postMessage(
      JSON.stringify({ event: "command", func: "playVideo", args: [] }),
      "*"
    );
  }

  // Handle Vimeo iframe
  handleVimeoClick(currentIframe) {
    this.pauseAll(currentIframe);
    currentIframe.contentWindow.postMessage(
      { method: "play" },
      "*"
    );
  }

  handleModelClick(currentModel) {
    if (currentModel.modelViewerUI) {
          currentModel.modelViewerUI.play();
        } 
    this.pauseAll(currentModel);
  }

  // Pause everything except the current
  pauseAll(except = null) {
    // HTML5 video
    this.videos.forEach((v) => {
      if (v !== except) {
        v.previousElementSibling.classList.remove('fade');
        v.pause();
      }
    });

    // YouTube
    this.youtubeIframes.forEach((iframe) => {
      if (iframe !== except) {
        iframe.nextElementSibling.style.pointerEvents = 'all';
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: "command", func: "pauseVideo", args: [] }),
          "*"
        );
      }
    });

    // Vimeo
    this.vimeoIframes.forEach((iframe) => {
      if (iframe !== except) {
        iframe.nextElementSibling.style.pointerEvents = 'all';
        iframe.contentWindow.postMessage({ method: "pause" }, "*");
      }
    });

    this.models.forEach((model) => {
      if(model !== except) {
        if (model.modelViewerUI) {
          model.modelViewerUI.pause();
        } 

        model.querySelector('.shopify-model-viewer-ui__button').removeAttribute('hidden');
      }
    })
  }
}

customElements.define('product-media', ProductMedia);


// ARTICLE RECOMMENDATIONS
class ArticleRecommendations extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.columns = this.dataset.columns;
    this.mobColumns = this.dataset.mobCols;
    this.spacing = this.dataset.spacing;
    this.slider = this.querySelector(`.ar_inner-${this.sectionId}`);    
  }

  connectedCallback() {
    if(this.slider) {
      const swiper = new Swiper(
      this.slider,
      {
        speed: 600,
        grabCursor: true,
        slidesPerView: this.columns,
        spaceBetween: this.spacing,
        navigation: {
          nextEl: `.next_btn-${this.sectionId}`,
          prevEl: `.prev_btn-${this.sectionId}`,
        },
        breakpoints: {
        0: {
          slidesPerView: this.mobColumns,
          spaceBetween: this.spacing,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: this.spacing,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: this.spacing,
        },
        1281: {
          slidesPerView: 4,
          spaceBetween: this.spacing,
        },                
        1399: {
          slidesPerView: this.columns,
          spaceBetween: this.spacing,
        },
      }
      }
    );    
    }
  }
}

customElements.define('article-recommendations', ArticleRecommendations);


// HERO TEXT IMAGE
class HeroTextImg extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.slider = this.querySelector(`.hr_text_img_wrapper-${this.sectionId}`);
    this.autoplaySpeed = Number(this.dataset.autoplaySpeed * 1000);
    this.effect = this.dataset.effect;
  }

  connectedCallback() {
    if(!this.slider) return;

    this.htSwiper = new Swiper(this.slider, {
      slidesPerView: 1,
      speed: 800,
      loop: true,
      autoplay: {
        delay: this.autoplaySpeed,
        disableOnInteraction: true,
      },
      effect: this.effect
    })
  }
}

customElements.define('hero-text-img', HeroTextImg);


// HERO TEXT BOTTOM LINK
class BottomLink extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('a');    
    this.next = this.closest('.shopify-section').nextElementSibling;   
}

  connectedCallback() {
    this.link.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    e.preventDefault();

    let headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    headerHeight = headerHeight.split('px')
    const top = this.next.getBoundingClientRect().top + window.scrollY - Number(headerHeight[0]);
    
    window.lenis.scrollTo(top, {
      duration: 1.5,
      easing: 'easeInOutCubic',
    });
  }
}

customElements.define('bottom-link', BottomLink);


// STICKY ADD TO CART
class StickyCart extends HTMLElement {
  constructor() {
    super();
    this.mainBtn = this.closest('product-info').querySelector('.add_to_cart_button');
    this.footerWrapper = document.querySelector('.footer_wrapper');   
    this.stickyWrapper = this.querySelector('.sticky_cart_wrapper');
    this.observerMainButton = null;
    this.observerFooter = null; 
    this.mainBtnVisible = true;  
    this.footerVisible = false;
  }

  connectedCallback() {
    if(!this.stickyWrapper || !this.footerWrapper) return;
    
    this.initObservers();

    this.closest('product-info').addEventListener('variant-change', () => {
      this.initObservers();
    })

    if (window.scrollY === 0) {
      this.stickyWrapper.classList.remove('active');
    }   
  }

  initObservers() {
    // Disconnect old observer if exists
    if (this.observerMainButton) this.observerMainButton.disconnect();

    const mainBtn = this.closest('product-info')?.querySelector('.add_to_cart_button');
    if (!mainBtn) return;

    // Observe main button visibility
    this.observerMainButton = new IntersectionObserver(
      ([entry]) => {
        this.mainBtnVisible = entry.isIntersecting;
        this.updateSticky();
      },
      { threshold: 0 }
    );
    this.observerMainButton.observe(mainBtn);

    // Observe footer visibility
    if (!this.observerFooter && this.footerWrapper) {
      this.observerFooter = new IntersectionObserver(
        ([entry]) => {
          this.footerVisible = entry.isIntersecting;
          this.updateSticky();
        },
        { threshold: 0 }
      );
      this.observerFooter.observe(this.footerWrapper);
    }
  }

  updateSticky() {
    // Show sticky button only if main button is not visible AND footer is not visible
    if (!this.mainBtnVisible && !this.footerVisible) {
      this.stickyWrapper.classList.add('active');
    } else {
      this.stickyWrapper.classList.remove('active');
    }
  } 
}

customElements.define('sticky-cart', StickyCart);


// COUNTDOWN TIMER
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.endDate = new Date(this.dataset.time).getTime();
    this.daysEl = this.querySelector(".countdown_days h2");
    this.hoursEl = this.querySelector(".countdown_hours h2");
    this.minutesEl = this.querySelector(".countdown_minutes h2");
    this.secondsEl = this.querySelector(".countdown_seconds h2");
    this.prev = { days: "", hours: "", minutes: "", seconds: "" };
    this.interval = null;
  }

  connectedCallback() {
    if (isNaN(this.endDate)) {
      this.showDefault();
      return;
    }
    this.startCountdown();
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  startCountdown() {
    this.updateCountdown(); // run once immediately
    this.interval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  animateChange(el, value, prevValue) {
    if (value !== prevValue) {
      el.textContent = String(value).padStart(2, "0");
      el.classList.remove("animate"); // reset animation
      void el.offsetWidth; // trigger reflow
      el.classList.add("animate");
    }
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate - now;

    if (distance <= 0) {
      clearInterval(this.interval);
      this.daysEl.textContent = "00";
      this.hoursEl.textContent = "00";
      this.minutesEl.textContent = "00";
      this.secondsEl.textContent = "00";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.animateChange(this.daysEl, days, this.prev.days);
    this.animateChange(this.hoursEl, hours, this.prev.hours);
    this.animateChange(this.minutesEl, minutes, this.prev.minutes);
    this.animateChange(this.secondsEl, seconds, this.prev.seconds);

    this.prev = { days, hours, minutes, seconds };
  }

  showDefault() {
    this.daysEl.textContent = "00";
    this.hoursEl.textContent = "00";
    this.minutesEl.textContent = "00";
    this.secondsEl.textContent = "00";
  }
}

customElements.define("countdown-timer", CountdownTimer);


// BEFORE/AFTER SLIDER
class BeforeAfter extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.beforeImg = this.querySelector('.ba_before_img');
    this.afterImg = this.querySelector('.ba_after_img');
    this.slider = this.querySelector('.ba_slider');;
    this.thumb = this.slider.querySelector('.ba_thumb');
    this.dragging = false;
  }

  connectedCallback() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.slider.classList.add('transition');
            this.afterImg.classList.add('transition');
            this.afterImg.classList.add('r_transition');
            this.slider.style.left = '50%';
            this.updateClip(0.5);

            setTimeout(() => {
              this.slider.classList.remove('transition');
              this.afterImg.classList.remove('r_transition');
            }, 600);
          }
        });
      },
      { threshold: 0.5 }
    );
    observer.observe(this);

    this.slider.addEventListener('mousedown', this.startDrag.bind(this));
    window.addEventListener('mouseup', this.stopDrag.bind(this));
    window.addEventListener('mousemove', this.onDrag.bind(this));

    this.slider.addEventListener('touchstart', this.startDrag.bind(this));
    window.addEventListener('touchend', this.stopDrag.bind(this));
    window.addEventListener('touchmove', this.onDrag.bind(this));
  }

    startDrag(e) {
    e.preventDefault();
    this.dragging = true;
    this.slider.style.cursor = 'grabbing';
  }

  stopDrag() {
    this.dragging = false;
    this.slider.style.cursor = 'grab';
  }

  
  onDrag(e) {
    if (!this.dragging) return;
    let clientX = e.clientX || (e.touches && e.touches[0].clientX);
    const rect = this.container.getBoundingClientRect();
    let pos = (clientX - rect.left) / rect.width;

    const min = 0.01;
    const max = 0.99;
    pos = Math.max(min, Math.min(max, pos));
    this.slider.style.left = `${pos * 100}%`;
    this.updateClip(pos);
  }

  updateClip(pos) {
    this.afterImg.style.clipPath = `inset(0 0 0 ${pos * 100}%)`;
  }
}

customElements.define('before-after', BeforeAfter);


// FAQ SECTION
class FaqSection extends HTMLElement {
  constructor() {
    super();
    this.questions = this.querySelectorAll('.faq_question');
  }

  connectedCallback() {
    this.questions.forEach((question) => {
      const answer = question.nextElementSibling;
      const answerInner = answer.querySelector('.faq_answer_inner');
      const height = answerInner.clientHeight;
      answer.style.setProperty('--height', `${height}px`);

      question.addEventListener('click', () => {
        const isActive = answer.classList.contains('active');

        // Close all
        this.questions.forEach((q) => {
          const ans = q.nextElementSibling;
          q.querySelector('.closed_eye').classList.remove('hidden');
          q.querySelector('.open_eye').classList.add('hidden');
          ans.classList.remove('active');
        });

        // If the clicked one was not active before, open it
        if (!isActive) {
          question.querySelector('.closed_eye').classList.toggle('hidden');
          question.querySelector('.open_eye').classList.toggle('hidden');
          answer.classList.add('active');
        }
      });

      question.querySelector('button').addEventListener('focusin', (e) => {
        const el = e.target;
        if(el.matches(':focus-visible')) {
          answer.classList.add('active')
        }
      })

      question.querySelector('button').addEventListener('focusout', (e) => {
        const el = e.target;
        if(el.matches(':focus-visible')) {
          answer.classList.remove('active')
        }
      })
    });
  }
}

customElements.define('faq-section', FaqSection);


document.addEventListener('DOMContentLoaded', () => {
  const vdos = document.querySelectorAll('video');

  if(vdos.length) {
    vdos.forEach((vdo) => {
      const img = vdo.querySelector('img');
      if(!img) return;

      img.setAttribute('alt', 'Video image');
    })
  }
})


// VERTICAL COLLECTIONS
class VerticalCollections extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.tab_item_wrapper');
    this.images = this.querySelectorAll('.tab-image-card');
  }

  connectedCallback() {
    if(this.tabs.length) {
      this.tabs.forEach((tab) => {
        tab.addEventListener('mouseenter', () => {
          const id = tab.dataset.tab;
          this.tabs.forEach((t) => {
            t.classList.remove('active');
          })
          tab.classList.add('active');
          if(this.images.length) {
            this.images.forEach((img) => {
              const image = img.dataset.image;
              if(id == image) {
                img.classList.add('active');
              } else {
                img.classList.remove('active');
              }
            })
          }
        })  
      })
    }
  }
}

customElements.define('vertical-collections', VerticalCollections);


// IMAGE HOTSPOTS
class ImageHotspots extends HTMLElement {
    constructor() {
      super();
      this.hotspots = this.querySelectorAll('.image_hotspot_wrapper');
      this.products = this.querySelectorAll('.ih_product');
    }

    connectedCallback() {
      this.hotspots.forEach((hotspot) => {
        const id = hotspot.dataset.id;
        hotspot.addEventListener('click', () => {
          this.hotspots.forEach((h) => {
            h.classList.remove('active');
          })
          hotspot.classList.add('active');
          this.handleClick(id);
        });
      });
    }

    handleClick(id) {
      this.products.forEach((product) => {
        let pid = product.dataset.id;
        if (id == pid) {
          product.classList.add('is_selected');
        } else {
          product.classList.remove('is_selected');
        }
      });
    }
  }

  customElements.define('image-hotspots', ImageHotspots);


  // BUNDLE SECTION
class BundleSection extends HTMLElement {
  constructor() {
    super();

    this.MAX_ITEMS = 3;

    this.selectedItems = [];

    this.bundleButtons = this.querySelectorAll('.add_to_bundle_btn');
    this.infoAddBtn = this.querySelector('.bp_info_btn .button');
    this.btnText = this.infoAddBtn.querySelector('.bp_btn_text');
    this.btnLoader = this.infoAddBtn.querySelector('.bp_btn_loader');
    this.expandBtn = this.querySelector('.pb_expand_btn');
    this.expandWrapper = this.querySelector('.bundle_section_info_inner');

    this.RENDER_DELAY = 500; // ms (adjust to taste)
    this.renderTimeouts = [];

    this.bundleSlots = [
      this.querySelector('.bundle_section_product1'),
      this.querySelector('.bundle_section_product2'),
      this.querySelector('.bundle_section_product3')
    ];

    this.defaultSlotHTML = this.bundleSlots.map(slot =>
      slot ? slot.innerHTML : ''
    );

    this.cart = document.querySelector('cart-drawer');
  }

  connectedCallback() {
    this.bindProductButtons();
    this.bindInfoButton();
    this.updateUIState();

    this.expandBtn.addEventListener('click', this.handleClick.bind(this));
  }

 /* ============================
     Product Info Section Expand
  ============================= */
  handleClick() {
    this.expandWrapper.classList.toggle('expand');
  }

  /* ============================
     Product Selection
  ============================= */
  bindProductButtons() {
    this.bundleButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleProduct(btn);
      });
    });
  }

  toggleProduct(btn) {
    const item = this.getItemFromButton(btn);
    const index = this.selectedItems.findIndex(
      (i) => i.variantId === item.variantId
    );

    /* Remove */
    if (index > -1) {
      this.selectedItems.splice(index, 1);
      this.setButtonState(btn, false);
      this.renderBundleSlots();
      this.updateUIState();
      return;
    }

    /* Add */
    if (this.selectedItems.length >= this.MAX_ITEMS) return;

    this.selectedItems.push(item);
    this.setButtonState(btn, true);
    this.renderBundleSlots();
    this.updateUIState();
  }

  getItemFromButton(btn) {
    return {
      variantId: btn.dataset.variantId,
      title: btn.dataset.title,
      price: btn.dataset.price,
      cap: btn.dataset.cap || null,
      image: btn.dataset.image
    };
  }

  /* ============================
     Bundle Slots Rendering
  ============================= */
  renderBundleSlots() {
  this.renderTimeouts.forEach(clearTimeout);
  this.renderTimeouts = [];

  this.bundleSlots.forEach((slot, index) => {
    if (!slot) return;

    const item = this.selectedItems[index];

    slot.classList.add('bundle-slot-loading');

    const timeout = setTimeout(() => {
      slot.classList.remove('bundle-slot-loading');

      if (!item) {
        slot.innerHTML = this.defaultSlotHTML[index];
        slot.classList.remove('filled');
        return;
      }

      const capPrice = item.cap ? `<s class="bp_cap_price">${item.cap}</s>` : '';

      slot.classList.add('filled');
      slot.innerHTML = `
          <div class="bp_product">
            <div class="bp_img">
              ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}
            </div>
            <div class="bp_info">
              <p class="bp_title">${item.title}</p>
              <div class="bp_price_wrapper">
              ${capPrice}
              <span class="bp_price">${item.price}</span>
              </div>
            </div>
          </div>
        `;
      }, this.RENDER_DELAY);

      this.renderTimeouts.push(timeout);
    });
  }


  /* ============================
     UI State
  ============================= */
  updateUIState() {
    const maxReached = this.selectedItems.length === this.MAX_ITEMS;

    this.bundleButtons.forEach((btn) => {
      if (maxReached) {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('button_disabled');
      } else {
        btn.removeAttribute('disabled');
        btn.classList.remove('button_disabled');
      }
    });

    maxReached
      ? this.enableButton(this.infoAddBtn)
      : this.disableButton(this.infoAddBtn);
  }

  setButtonState(btn, isAdded) {
    const label = btn.querySelector('.btn_label');
    if (!label) return;

    label.textContent = isAdded ? 'Added' : 'Add to bundle';
    btn.classList.toggle('is-added', isAdded);
  }

  /* ============================
     Add to Cart
  ============================= */
  bindInfoButton() {
    if (!this.infoAddBtn) return;

    this.infoAddBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if(this.btnText) {
        this.btnText.classList.add('hidden');
      }
      if(this.btnLoader) {
        this.btnLoader.classList.remove('hidden');
      }
      this.addBundleToCart();
    });
  }

  async addBundleToCart() {
    if (this.selectedItems.length !== this.MAX_ITEMS) return;

    const items = this.selectedItems.map((item) => ({
      id: item.variantId,
      quantity: 1
    }));

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Add to cart failed');

      /* ----------------------------
        CART UPDATE HANDLING
      ----------------------------- */
      if (this.cart) {
        const rawCartData = await fetch(
          `${window.Shopify.routes.root}?sections=cart-drawer,cart-count,main-cart`
        ).then((res) => res.json());

        const cart = await fetch(
          `${window.Shopify.routes.root}cart.js`
        ).then((res) => res.json());

        const cartData = {
          cart,
          sections: rawCartData,
          button: this.infoAddBtn
        };

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        );
      } else {
        window.location.href = `${window.Shopify.routes.root}cart`;
      }

      this.resetBundle();
      if(this.btnText) {
        this.btnText.classList.remove('hidden');
      }
      if(this.btnLoader) {
        this.btnLoader.classList.add('hidden');
      }

    } catch (error) {
      console.error(error);
    }
  }


  /* ============================
     Helpers
  ============================= */
  disableButton(btn) {
    if (!btn) return;
    btn.setAttribute('disabled', 'disabled');
    btn.classList.add('button_disabled');
  }

  enableButton(btn) {
    if (!btn) return;
    btn.removeAttribute('disabled');
    btn.classList.remove('button_disabled');
  }

  resetBundle() {
    this.selectedItems = [];

    this.bundleButtons.forEach((btn) => {
      this.setButtonState(btn, false);
      btn.removeAttribute('disabled');
      btn.classList.remove('button_disabled');
    });

    this.bundleSlots.forEach((slot, index) => {
      if (!slot) return;
      slot.innerHTML = this.defaultSlotHTML[index];
      slot.classList.remove('filled');
    });

    this.disableButton(this.infoAddBtn);
  }
}

customElements.define('bundle-section', BundleSection);